import { createGlobalStyle } from 'styled-components/macro';
import 'react-pro-sidebar/dist/css/styles.css';
import icomoonEOt from '../assets/fonts/icomoon.eot';
import icomoonSVG from '../assets/fonts/icomoon.svg';
import icomoonTFF from '../assets/fonts/icomoon.ttf';
import icomoonWOTFF from '../assets/fonts/icomoon.woff';

export default createGlobalStyle `

@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@100;300;400;500;600;700&display=swap');

#root {
	overflow: hidden !important;
}

canvas {
	max-height: 300px;
}

.react-calendar {
	border: none !important;
}


* {
	--primary-color: #2C97DE;
	--grey-color: #647482;
	--light-grey-color: #e6e6e6;
	--white-color: #fff;
	--text-dark: #253858;
	--bg-dark: #253858;
	--warning-color: #E25F70;
	--success-color: #5FCB44;
	--grey-shade: #F4F5F6;
	--btn-orange-color: #D57A32;
	--dark-color: #333333;
	/* them description buttons variables */
	--theme-topic-button-bgcolor: #D57A32;
	--theme-topic-button-color: #fff;
	/* font variables */
	font-family: 'Poppins', sans-serif;
	--font-thin: 300;
	--font-regular: 400;
	--font-medium: 500;
	--font-semi-bold: 600;
	--font-bold: 700;
	box-sizing: border-box;
	/* action buyttons dynamic variables */
	--btn-blocked-color: #000;
	--btn-blocked-bgcolor: #fff;
	--btn-blocked-border-color: #e6e6e6;
}

html {
	font-family: 'Poppins', sans-serif;
	font-weight: 400;
	height: 100%;
	margin: 0;
	padding: 0;
	font-size: 13px;
}

body {
	margin: 0;
	padding: 0;
	height: 100%;
}

.maps-no-data {
	margin-top:-1rem;
    align-items: center;
    justify-content: center;
    display: flex;
    border: 1px solid var(--grey-shade);
	margin-bottom: 20px;
}

.image-name {
	display: inline-block;
	white-space: nowrap;
    min-width: 80px;
	max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
	text-align: center;
    vertical-align: middle;
}

.website-title {
	width: 110px;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.text-uppercase{
	text-transform: uppercase !important;
}

.titleCase {
	text-transform: capitalize !important;
}

/* @font-face {
    font-family: 'Poppins';
    src: url('../fonts/poppins-bold-webfont.eot');
    src: url('../fonts/poppins-bold-webfont.eot?#iefix') format('embedded-opentype'),
         url('../fonts/poppins-bold-webfont.woff2') format('woff2'),
         url('../fonts/poppins-bold-webfont.woff') format('woff'),
         url('../fonts/poppins-bold-webfont.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
}
@font-face {
    font-family: 'Poppins';
    src: url('../fonts/poppins-light-webfont.eot');
    src: url('../fonts/poppins-light-webfont.eot?#iefix') format('embedded-opentype'),
         url('../fonts/poppins-light-webfont.woff2') format('woff2'),
         url('../fonts/poppins-light-webfont.woff') format('woff'),
         url('../fonts/poppins-light-webfont.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
}
@font-face {
    font-family: 'Poppins';
    src: url('../fonts/poppins-medium-webfont.eot');
    src: url('../fonts/poppins-medium-webfont.eot?#iefix') format('embedded-opentype'),
         url('../fonts/poppins-medium-webfont.woff2') format('woff2'),
         url('../fonts/poppins-medium-webfont.woff') format('woff'),
         url('../fonts/poppins-medium-webfont.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
}
@font-face {
    font-family: 'Poppins';
    src: url('../fonts/poppins-regular-webfont.eot');
    src: url('../fonts/poppins-regular-webfont.eot?#iefix') format('embedded-opentype'),
         url('../fonts/poppins-regular-webfont.woff2') format('woff2'),
         url('../fonts/poppins-regular-webfont.woff') format('woff'),
         url('../fonts/poppins-regular-webfont.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
}
@font-face {
    font-family: 'Poppins';
    src: url('../fonts/poppins-semibold-webfont.eot');
    src: url('../fonts/poppins-semibold-webfont.eot?#iefix') format('embedded-opentype'),
         url('../fonts/poppins-semibold-webfont.woff2') format('woff2'),
         url('../fonts/poppins-semibold-webfont.woff') format('woff'),
         url('../fonts/poppins-semibold-webfont.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
} */

@font-face {
  font-family: 'icomoon';
  src:  url('${icomoonEOt}');
  src:  url('${icomoonEOt}') format('embedded-opentype'),
    url('${icomoonTFF}') format('truetype'),
    url('${icomoonWOTFF}') format('woff'),
    url('${icomoonSVG}') format('svg');
  font-weight: normal;
  font-style: normal;
  font-display: block;
}

[class^="icon-"],
[class*=" icon-"] {
	/* use !important to prevent issues with browser extensions that change fonts */
	font-family: 'icomoon' !important;
	speak: never;
	font-style: normal;
	font-weight: normal;
	font-variant: normal;
	text-transform: none;
	line-height: 1;
	/* Better Font Rendering =========== */
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}

.icon-2x {
	font-size: 1.5rem;
}

.icon-info:before {
	content: "\\ea0c";
}

.icon-wesbites:before {
	content: "\\e901";
}

.icon-settings:before {
	content: "\\e902";
}

.icon-dashboard:before {
	content: "\\e903";
}

.icon-subscribers:before {
	content: "\\e904";
}

.icon-automation:before {
	content: "\\e905";
}

.icon-segmentation:before {
	content: "\\e906";
}

.icon-campaigns:before {
	content: "\\e907";
}

.icon-bill:before {
	content: "\\e908";
}

.icon-trash:before {
	content: "\\e909";
}

.icon-setting:before {
	content: "\\e90a";
}

.icon-currency:before {
	content: "\\e90b";
}

.icon-file-extended:before {
	content: "\\e90c";
}

.icon-logout:before {
	content: "\\e90d";
}

.icon-arrow-down:before {
	content: "\\e90e";
}

.icon-web-link:before {
	content: "\\e90f";
}

.icon-chevron-right:before {
	content: "\\e910";
}

.icon-ctrl:before {
	content: "\\ea50";
}

.icon-arrow-up:before {
	content: "\\e900";
}

.icon-add:before {
	content: "\\e911";
}

.icon-minus:before {
	content: "\\e912";
}

.icon-subscriber:before {
	content: "\\e913";
}

.icon-campaign-sent:before {
	content: "\\e914";
}

.icon-password:before {
	content: "\\e915";
}

.icon-edit:before {
	content: "\\e916";
}

.icon-delete:before {
	content: "\\e917";
}

.icon-edit-inline:before {
	content: "\\e918";
}

.icon-file:before {
	content: "\\e919";
}

.icon-search:before {
	content: "\\e91a";
}

.icon-close:before {
	content: "\\e91b";
}

.icon-calendar:before {
	content: "\\e91c";
}

.icon-time:before {
	content: "\\e91d";
}

.icon-close-enhanced:before {
	content: "\\e91e";
}

.icon-chevron-left:before {
	content: "\\e91f";
}

.icon-chevron-down:before {
	content: "\\e91f";
}

.icon-lock:before {
	content: "\\e98f";
  }

.icon-down {
	color: black !important;;
    transform: rotate(270deg) !important;;
    font-size: 9px !important;;
    font-weight: bold !important;;
	top: calc(50% - 9px) !important;;
	background: none !important;
}



.icon-refresh:before {
	content: "\\e920";
}

.icon-help:before {
	font-weight: bold;
	font-size: 18px;
	content: "\\e921";
}

.icon-help:hover {
	color: var(--primary-color);
}

.icon-image:before {
	content: "\\e922";
}

.icon-thumb-menu:before {
	content: "\\e923";
}

.icon-check:before {
	content: "\\e924";
}

.icon-eye:before {
	content: "\\e925";
}

.icon-Vector-38:before {
	content: "\\e926";
}

.icon-Vector-39:before {
	content: "\\e927";
}

.icon-money:before {
	content: "\\e928";
}

.icon-bug:before {
	content: "\\e929";
}

.icon-chrome:before {
	content: "\\e92a";
}

.icon-copy:before {
	content: "\\e92b";
}

.icon-copy:hover {
	content: "\\e92b";
	font-weight: bold;
}

.icon-feed:before {
	content: "\\e92c";
}

.icon-logout-enhanced:before {
	content: "\\e92d";
}

.icon-Vector-46:before {
	content: "\\e92e";
}

.icon-website-published:before {
	content: "\\e92f";
}

.icon-safari:before {
	content: "\\e930";
}

.icon-send:before {
	content: "\\e931";
}

.icon-Vector-50:before {
	content: "\\e932";
}

.icon-password-mask:before {
	content: "\\e933";
}

.icon-mail:before {
	content: "\\e934";
}

.icon-security:before {
	content: "\\e935";
}

.icon-user:before {
	content: "\\e936";
}

.icon-notification:before {
	content: "\\e937";
}

.icon-profile:before {
	content: "\\e938";
}

.icon-website:before {
	content: "\\e939";
}


/* reset css */

article,
aside,
dialog,
figcaption,
figure,
footer,
header,
hgroup,
main,
nav,
section {
	display: block;
}

h1,
h2,
h3,
h4,
h5,
h6 {
	margin-top: 0;
	margin-bottom: 0.5rem;
}

p {
	margin-top: 0;
	margin-bottom: 0;
	line-height: 1.25;
}

abbr[title],
abbr[data-original-title] {
	text-decoration: underline;
	-webkit-text-decoration: underline dotted;
	text-decoration: underline dotted;
	cursor: help;
	border-bottom: 0;
}

address {
	margin-bottom: 1rem;
	font-style: normal;
	line-height: inherit;
}

b,
strong {
	font-weight: bolder;
}

small {
	font-size: 80%;
}

sub,
sup {
	position: relative;
	font-size: 75%;
	line-height: 0;
	vertical-align: baseline;
}

sub {
	bottom: -.25em;
}

sup {
	top: -.5em;
}

ol,
ul,
dl {
	margin-top: 0;
	margin-bottom: 1rem;
}

a {
	color: #007bff;
	text-decoration: none;
	background-color: transparent;
	cursor:pointer;
	-webkit-text-decoration-skip: objects;
}

.anchor-none,
.anchor-none:hover {
	text-decoration: none;
}

a:hover {
	color: #0056b3;
	text-decoration: underline;
}

a:not([href]):not([tabindex]) {
	color: inherit;
	text-decoration: none;
}

a:not([href]):not([tabindex]):hover,
a:not([href]):not([tabindex]):focus {
	color: inherit;
	// text-decoration: none;
}

a:not([href]):not([tabindex]):focus {
	outline: 0;
}

hr {
	border-top: 1px solid #e6e6e6;
}

.mr-auto,
.mx-auto {
	margin-right: auto !important;
}

.ml-auto,
.mx-auto {
	margin-left: auto !important;
}

figure {
	margin: 0 0 1rem;
}

img {
	vertical-align: middle;
	border-style: none;
}

svg:not(:root) {
	overflow: hidden;
}

table {
	border-collapse: collapse;
}

.subscribers-table .custom-select-sm {
	min-width: 11rem;
}

.subscribers-table .custom-select-sm .form-control {
	font-size: 0.875rem;
}

.subscribers-table tbody td {
	white-space: nowrap;
}

.subscribers-table .icon-check {
	font-size: 0.875rem;
	color: #253858;
}

.subscription-table.table-responsive {
	border: 0;
}

.subscription-table thead th {
}

.subscription-table thead th:first-child {
	min-width: 150px;
}

.subscription-table thead th:nth-child(2) {
	min-width: 100px;
}

caption {
	padding-top: 0.75rem;
	padding-bottom: 0.75rem;
	color: #6c757d;
	text-align: left;
	caption-side: bottom;
}

th {
	text-align: inherit;
}

label {
	display: inline-block;
	margin-bottom: .5rem;
}

button {
	border-radius: 0;
}

button:focus {
	outline: 1px dotted;
	outline: none;
}

input,
button,
select,
optgroup,
textarea {
	margin: 0;
	font-family: inherit;
	font-size: inherit;
	line-height: inherit;
}

button,
input {
	overflow: visible;
}

button,
select {
	text-transform: none;
}

button,
html [type="button"],
[type="reset"],
[type="submit"] {
	-webkit-appearance: button;
}

button::-moz-focus-inner,
[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner {
	padding: 0;
	border-style: none;
}


/* input[type="radio"],
  input[type="checkbox"] {
    box-sizing: border-box;
    padding: 0;
  } */

input[type="date"],
input[type="time"],
input[type="datetime-local"],
input[type="month"] {
	-webkit-appearance: listbox;
}
.form-check{
	display:flex;
	align-items:center;
}
input[type="color"] {
	min-width: 30px;
	max-width: 30px;
	height: 30px;
	padding: 2px;
	background-color: transparent;
	border-color: #e6e6e6;
}

input[type="color"]:focus,
input[type="color"]:hover {
	background: none;
	box-shadow: none;
}

textarea {
	overflow: auto;
	resize: vertical;
}

[hidden] {
	display: none !important;
}

h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
	margin-bottom: 0.5rem;
	font-family: inherit;
	font-weight: 600;
	line-height: 1.2;
	color: inherit;
}

h1,
.h1 {
	font-size: 2.5rem;
}

h2,
.h2 {
	font-size: 2rem;
}

h3,
.h3 {
	font-size: 1.75rem;
}

h4,
.h4 {
	font-size: 1.5rem;
}

h5,
.h5 {
	font-size: 1.25rem;
}

h6,
.h6 {
	font-size: 1rem;
}

.d-none {
	display: none !important;
}


/* font-weight css */

.thin {
	font-weight: var(--font-thin);
}

.regular {
	font-weight: var(--font-regular);
}

.medium {
	font-weight: var(--font-medium);
}

.semi-bold {
	font-weight: var(--font-semi-bold);
}

.bold {
	font-weight: var(--font-bold);
}


/* grid */

.container-fluid {
	width: 100%;
	padding-right: 15px;
	padding-left: 15px;
	margin-right: auto;
	margin-left: auto;
}

.row {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-ms-flex-wrap: wrap;
	flex-wrap: wrap;
	margin-right: -15px;
	margin-left: -15px;
}

.no-gutters {
	margin-right: 0;
	margin-left: 0;
}

.no-gutters>.col,
.no-gutters>[class*="col-"] {
	padding-right: 0;
	padding-left: 0;
}

.col-1,
.col-2,
.col-3,
.col-4,
.col-5,
.col-6,
.col-7,
.col-8,
.col-9,
.col-10,
.col-11,
.col-12,
.col,
.col-auto,
.col-sm-1,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-sm,
.col-sm-auto,
.col-md-1,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-10,
.col-md-11,
.col-md-12,
.col-md,
.col-md-auto,
.col-lg-1,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-lg,
.col-lg-auto,
.col-xl-1,
.col-xl-2,
.col-xl-3,
.col-xl-4,
.col-xl-5,
.col-xl-6,
.col-xl-7,
.col-xl-8,
.col-xl-9,
.col-xl-10,
.col-xl-11,
.col-xl-12,
.col-xl,
.col-xl-auto {
	position: relative;
	width: 100%;
	min-height: 1px;
	padding-right: 15px;
	padding-left: 15px;
}

.col {
	-ms-flex-preferred-size: 0;
	flex-basis: 0;
	-webkit-box-flex: 1;
	-ms-flex-positive: 1;
	flex-grow: 1;
	max-width: 100%;
}

.col-auto {
	-webkit-box-flex: 0;
	-ms-flex: 0 0 auto;
	flex: 0 0 auto;
	width: auto;
	max-width: none;
}

.col-1 {
	-webkit-box-flex: 0;
	-ms-flex: 0 0 8.333333%;
	flex: 0 0 8.333333%;
	max-width: 8.333333%;
}

.col-2 {
	-webkit-box-flex: 0;
	-ms-flex: 0 0 16.666667%;
	flex: 0 0 16.666667%;
	max-width: 16.666667%;
}

.col-3 {
	-webkit-box-flex: 0;
	-ms-flex: 0 0 25%;
	flex: 0 0 25%;
	max-width: 25%;
}

.col-4 {
	-webkit-box-flex: 0;
	-ms-flex: 0 0 33.333333%;
	flex: 0 0 33.333333%;
	max-width: 33.333333%;
}

.col-5 {
	-webkit-box-flex: 0;
	-ms-flex: 0 0 41.666667%;
	flex: 0 0 41.666667%;
	max-width: 41.666667%;
}

.col-6 {
	-webkit-box-flex: 0;
	-ms-flex: 0 0 50%;
	flex: 0 0 50%;
	max-width: 50%;
}

.col-7 {
	-webkit-box-flex: 0;
	-ms-flex: 0 0 58.333333%;
	flex: 0 0 58.333333%;
	max-width: 58.333333%;
}

.col-8 {
	-webkit-box-flex: 0;
	-ms-flex: 0 0 66.666667%;
	flex: 0 0 66.666667%;
	max-width: 66.666667%;
}

.col-9 {
	-webkit-box-flex: 0;
	-ms-flex: 0 0 75%;
	flex: 0 0 75%;
	max-width: 75%;
}

.col-10 {
	-webkit-box-flex: 0;
	-ms-flex: 0 0 83.333333%;
	flex: 0 0 83.333333%;
	max-width: 83.333333%;
}

.col-11 {
	-webkit-box-flex: 0;
	-ms-flex: 0 0 91.666667%;
	flex: 0 0 91.666667%;
	max-width: 91.666667%;
}

.col-12 {
	-webkit-box-flex: 0;
	-ms-flex: 0 0 100%;
	flex: 0 0 100%;
	max-width: 100%;
}

.full-height, #root {
	height: 100%;
}

.half-height {
	height: 50%;
}

.full-width {
	width: 100%;
}

.scrollable_y {
	overflow-y: auto;
}

.float-right {
	float: right;
}

.float-left {
	float: left;
}
::-webkit-scrollbar {
	width: 4px;
	height: 5px;
}
.navigation-menu.scrollable_y::-webkit-scrollbar {
	width: 0px;
	height: 5px;
}
.scrollable-thin_y::-webkit-scrollbar {
	width: 0px;
	height: 5px;
}
::-webkit-scrollbar-track {
	-webkit-box-shadow: inset 0 0 4px rgba(37, 56, 88, 1);
	border-radius: 5px;
}

::-webkit-scrollbar-thumb {
	border-radius: 5px;
	-webkit-box-shadow: inset 0 0 3px rgba(37, 56, 88, 0.5);
}


/* form css */

.error-message {
	font-size: 0.875rem;
	color: var(--warning-color);
}

.form-control {
	display: block;
	width: 100%;
	padding: 0.375rem 0.75rem;
	font-size: 1rem;
	line-height: 1.5;
	color: #495057;
	background-color: #fff;
	background-clip: padding-box;
	border: 1px solid #E6E6E6;
	border-radius: 0.25rem;
	transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.form-control::-ms-expand {
	background-color: transparent;
	border: 0;
}

.form-control:focus {
	color: #495057;
	background-color: #fff;
	border-color: #E6E6E6;
	outline: 0;
	box-shadow: none;
}

.form-control::-webkit-input-placeholder {
	color: #647482;
	opacity: 1;
	font-weight: 300;
}

.form-control::-moz-placeholder {
	color: #647482;
	opacity: 1;
	font-weight: 300;
}

.form-control:-ms-input-placeholder {
	color: #647482;
	opacity: 1;
	font-weight: 300;
}

.form-control::-ms-input-placeholder {
	color: #647482;
	opacity: 1;
	font-weight: 300;
}

.form-control::placeholder {
	color: #647482;
	opacity: 1;
	font-weight: 300;
}

.form-row {
	display: flex;
	flex-wrap: wrap;
	margin-right: -15px;
	margin-left: -15px;
}

.form-control:disabled,
.form-control[readonly] {
	background-color: #e9ecef;
	opacity: 1;
	font-weight: 300;
}

select.form-control:not([size]):not([multiple]) {
	height: calc(2.25rem + 2px);
}

select.form-control:focus::-ms-value {
	color: #495057;
	background-color: #fff;
}

.form-group {
	margin-bottom: 1rem;
	font-weight: 300;
}

.form-inline {
	display: flex;
	flex-flow: row wrap;
	-ms-flex-align: center;
	align-items: center;
}

.form-inline label {
	display: -ms-flexbox;
	display: flex;
	-ms-flex-align: center;
	align-items: center;
	-ms-flex-pack: center;
	justify-content: center;
	margin-bottom: 0;
}

.form-inline .form-control {
	display: inline-block;
	width: auto;
	vertical-align: middle;
}

.input-addon {
	position: relative;
}

.input-group-addon {
	display: flex;
	border-radius: 4px;
	border: 1px solid #e6e6e6;
}

.form-control:disabled,
.form-control[readonly] {
	background: var(--white-color);
}

.input-group-addon .form-control {
	border: 0;
}

.input-group-addon select {
	background: #F4F5F6;
}

select {
	outline: none;
	border-color: #F4F5F6;
}

.input-group-addon select {
	border: 0;
}

.input-addon.input-group-left i,
.input-addon.input-group-right i {
	position: absolute;
	left: 15px;
	top: calc(50% - 7px);
	color:#647482;
}
.input-addon input[type="password"] + i{
	position:relative;
	left:unset;
	top:unset;
}
.input-addon .btn{
	position:absolute;
	top:calc(50% - 4px);
	right:20px;
}
.input-addon.input-group-right i {
	background: #e6e6e6;
	padding: 5px;
	left: auto;
	right: 5px;
	top: calc(50% - 11px);
	border-radius: 3px;
}

.button-addon-right .btn {
	position: absolute;
	right: 0;
	top: 0;
	bottom: 0;
	border-radius: 0 0.25rem 0.25rem 0;
}

.input-addon.input-group-left .form-control {
	padding-left: 40px;
}

.input-addon.input-group-right .form-control {
	padding-right: 40px;
}
.input-addon input[type="password"]{
	padding-right: 40px;
}
.custom-file-input::-webkit-file-upload-button {
	visibility: hidden;
}

.custom-fileupload {
	position: relative;
}
.custom-fileupload span{
	margin-left: 0.5rem;
	display:inline-block;
}
.custom-file-input {
	min-width: 8rem;
	max-width: 8rem;
	border-radius: 0.25rem;
	position:relative;
}

.custom-file-input::before {
	content: 'Select File';
	display: inline-block;
	background: #e6e6e6;
	border: 1px solid #e6e6e6;
	border-radius: 3px;
	padding: 7px 15px 7px 32px;
	outline: none;
	white-space: nowrap;
	-webkit-user-select: none;
	cursor: pointer;
	font-weight: 500;
	font-size: 0.975rem;
}

.custom-file-rounded .custom-file-input {
	height: 7rem;
	border-radius: 50%;
	max-width: 7rem;
	min-width: 7rem;
	border: 1px dashed #647482;
	background: #f4f5f6;
}

.custom-file-rounded .custom-file-input::before {
	content: "Add Image";
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;
	width: 100%;
	padding: 0;
	background: transparent;
	text-align: center;
	white-space: normal;
	word-break: break-word;
	margin: 0 auto;
	border: 0;
	width: 50%;
}

.custom-file-rounded .custom-file-input:active::before,
.custom-file-rounded .custom-file-input:hover::before {
	background: #F4F5F6;
}

.custom-fileupload i {
	position: absolute;
	top: 9px;
	left: 12px;
}

.custom-file-input:hover::before {
	border-color: #e6e6e6;
}

.custom-file-input:active::before {
	background: -webkit-linear-gradient(top, #e3e3e3, #f9f9f9);
}
.file-upload {
	min-width: 125px;
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	background: #e6e6e6;
	border: 1px solid #e6e6e6;
	border-radius: 3px;
	padding: 8px;
	outline: none;
	overflow: hidden;
	color: #333;
	font-size: 0.975rem;
	font-weight:500;
}
.file-upload input[type=file] {
	height: 100%;
	width: 100%;
	position: absolute;
	top: 0;
	left: 0;
	opacity: 0;
	cursor: pointer;
}
.file-upload i {
	margin-right: 5px;
	display: inline-block;
}
.btn {
	display: inline-block;
	font-weight: 400;
	text-align: center;
	white-space: nowrap;
	vertical-align: middle;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
	border: 1px solid #d4d4d4;
	padding: 0.375rem 0.75rem;
	font-size: 0.875rem;
	line-height: 1.5;
	border-radius: 0.25rem;
	transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
	 border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.btn i{
	font-size:1rem;
}
.btn-group>.btn {
	position: relative;
	-ms-flex: 1 1 auto;
	flex: 1 1 auto;
}

.btn-group>.btn:not(:last-child):not(.dropdown-toggle) {
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
}

.btn-group>.btn:not(:first-child) {
	border-top-left-radius: 0;
	border-bottom-left-radius: 0;
	margin-left: 0px;
}

.btn:hover,
.btn:focus {
	text-decoration: none;
}

.btn:focus,
.btn.focus {
	outline: 0;
	box-shadow: none;
}

.btn.disabled,
.btn:disabled {
	opacity: 0.65;
}

.btn:not(:disabled):not(.disabled) {
	cursor: pointer;
}

.btn:not(:disabled):not(.disabled):active,
.btn:not(:disabled):not(.disabled).active {
	background-image: none;
}

a.btn.disabled,
fieldset:disabled a.btn {
	pointer-events: none;
}

.btn-block {
	display: block;
	width: 100%;
}

.btn-primary {
	color: #fff;
	background-color: var(--primary-color);
	border-color: var(--primary-color);
}

.btn-yellow {
	color: #fff;
	background-color: #F3DC49;
	border-color: #F3DC49;
}

.btn-primary-outline {
	color: var(--primary-color);
	background-color: var(--white-color);
	border-color: var(--primary-color);
}

.btn-secondary {
	color: #fff;
	background-color: #6c757d;
	border-color: #6c757d;
}

.btn-link {
	font-weight: 400;
	color: var(--primary-color);
	background-color: transparent;
}

.btn-rounded-lg {
	width: 4rem;
	height: 4rem;
	border-radius: 50%;
	line-height: 1;
}

.btn-grey,
.btn-grey:focus,
.btn-grey:hover {
	font-weight: 400;
	background: var(--light-grey-color);
	color: var(--text-dark);
}

.btn-link:hover {
	color: var(--primary-color);
	text-decoration: none;
	background-color: transparent;
	border-color: transparent;
}

.btn-link:focus,
.btn-link.focus {
	border-color: transparent;
	box-shadow: none;
	text-decoration: none;
	color: var(--primary-color);
}

.btn-link:disabled,
.btn-link.disabled {
	color: #6c757d;
}

.btn-neutral,
.btn-neutral:focus,
.btn-neutral:hover {
	background: transparent;
	border: 0;
	box-shadow: none;
}

.btn-outline {
	color: var(--text-dark);
	background: transparent;
}

.btn-outline:hover {
	background: var(--primary-color);
	color: var(--white-color);
	border-color: var(--primary-color);
	box-shadow: 0;
}

.btn-danger {
	background: var(--warning-color);
	color: var(--white-color);
}

.btn-orange {
	background: var(--btn-orange-color);
	border-color: var(--btn-orange-color);
	color: var(--white-color);
	border-radius: 0;
}

.btn-success {
	min-width: 8rem;
	color: var(--text-dark);
	background: transparent;
}

.btn-success:hover {
	color: var(--white-color);
	background: var(--success-color);
	border-color: var(--success-color);
	box-shadow: 0;
}

.btn-failure {
	min-width: 8rem;
	color: var(--text-dark);
	background: transparent;
}

.btn-failure:hover {
	color: var(--white-color);
	background: var(--warning-color);
	border-color: var(--warning-color);
	box-shadow: 0;
}

.btn-xs {
	min-width: 3rem;
	font-size: 0.975rem;
}

.btn-sm {
	min-width: 6rem;
}

.btn-md {
	min-width: 8rem;
}


/* modal css */

.modal {
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: 1050;
	display: none;
	overflow: hidden;
	outline: 0;
}

.modal-medium .modal-dialog {
	min-width: 300px;
}

.masonry-modal {
	max-height: 95vh;
}

.modal-open .modal {
	overflow-x: hidden;
	overflow-y: auto;
}

.modal-dialog {
	position: relative;
	width: auto;
	margin: 0.5rem;
	pointer-events: none;
}

.modal.fade .modal-dialog {
	transition: -webkit-transform 0.3s ease-out;
	transition: transform 0.3s ease-out;
	transition: transform 0.3s ease-out, -webkit-transform 0.3s ease-out;
	-webkit-transform: translate(0, -25%);
	transform: translate(0, -25%);
}

.modal.show .modal-dialog {
	-webkit-transform: translate(0, 0);
	transform: translate(0, 0);
}

.modal.rss-modal.show .modal-dialog {
	-webkit-transform: translate(0, 50%);
	transform: translate(0, 50%);
}

.modal-dialog-centered {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	min-height: calc(100% - (0.5rem * 2));
}

.modal-content {
	position: relative;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-ms-flex-direction: column;
	flex-direction: column;
	width: 100%;
	pointer-events: auto;
	background-color: #fff;
	background-clip: padding-box;
	border: 1px solid rgba(0, 0, 0, 0.2);
	border-radius: 0.3rem;
	outline: 0;
}

.modal-backdrop {
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: 1040;
	background-color: #000;
}

.modal-backdrop.fade {
	opacity: 0;
}

.modal.show {
	display: block;
}

.modal-backdrop.fade {
	opacity: 0.5;
}

.modal-header {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: start;
	-ms-flex-align: start;
	align-items: flex-start;
	-webkit-box-pack: justify;
	-ms-flex-pack: justify;
	justify-content: space-between;
	padding: 1rem;
	border-bottom: 1px solid #e9ecef;
	border-top-left-radius: 0.3rem;
	border-top-right-radius: 0.3rem;
}

.modal-header .close {
	padding: 1rem;
	margin: -1rem -1rem -1rem auto;
}

.modal-title {
	margin-bottom: 0;
	line-height: 1.5;
}

.modal-body {
	position: relative;
	-webkit-box-flex: 1;
	-ms-flex: 1 1 auto;
	flex: 1 1 auto;
	padding: 1rem;
}

.modal-footer {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	-webkit-box-pack: end;
	-ms-flex-pack: end;
	justify-content: flex-end;
	padding: 1rem;
	border-top: 1px solid #e9ecef;
}

.modal-footer> :not(:first-child) {
	margin-left: .25rem;
}

.modal-footer> :not(:last-child) {
	margin-right: .25rem;
}

.abbr {
	width: 2.875rem;
	height: 2.875rem;
	border-radius: 50%;
	border: 1px solid #E6E6E6;
	display: flex;
	align-content: center;
	justify-content: center;
	margin: 0;
	line-height: 2.875rem;
}


/* masonry grid */

img {
	max-width: 100%;
	height: auto;
	vertical-align: middle;
	display: inline-block;
}


/* Main CSS */

.grid-wrapper>div {
	display: flex;
	justify-content: center;
	align-items: center;
}

.grid-wrapper>div>img {
	width: 100%;
	height: 100%;
	object-fit: cover;
	border-radius: 5px;
}

.grid-wrapper {
	display: grid;
	grid-gap: 10px;
	grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
	grid-auto-rows: 200px;
	grid-auto-flow: dense;
}

.grid-wrapper .wide {
	grid-column: span 2;
}

.grid-wrapper .tall {
	grid-row: span 2;
}

.grid-wrapper .big {
	grid-column: span 2;
	grid-row: span 2;
}


/* */


/* data list */

.data-list-item {
	display: flex;
	align-items: flex-start;
	font-size: 1rem;
	font-weight: 400;
	margin-bottom: 0.25rem;
}

.data-list-item .data-label {
	display: inline-block;
	color: var(--grey-color);
	min-width: 6rem;
}

.data-list-item .data-description {
	color: var(--text-dark);
}

.box {
	font-weight: 500;
	color: var(--text-dark);
	padding: 0.75rem 1rem;
	border-radius: 4px;
	background: var(--grey-shade);
}

.box-cost {
    color: var(--text-dark);
    padding: 1rem 2rem;
    border-radius: 0.75rem;
    background: var(--grey-shade);
    margin-left: -20px;
    margin-right: -20px;
}

.box-lg {
	padding: 3rem 1rem;
	border: 1px solid #e6e6e6;
	background: #fff;
}

.box+.box {
	margin-top: 0.5rem;
}


/* flex utilities */

.d-flex {
	display: flex !important;
}

.d-inline-flex {
	display: inline-flex;
}

.flex-row {
	flex-direction: row;
}

.flex-row-reverse {
	flex-direction: row-reverse;
}

.flex-column {
	flex-direction: column;
}

.flex-column-reverse {
	flex-direction: column-reverse;
}

.flex-wrap {
	flex-wrap: wrap;
}

.flex-nowrap {
	flex-wrap: nowrap;
}

.flex-wrap-reverse {
	flex-wrap: wrap-reverse;
}

.justify-content-start {
	-webkit-box-pack: start !important;
	-ms-flex-pack: start !important;
	justify-content: flex-start !important;
}

.justify-content-end {
	-webkit-box-pack: end !important;
	-ms-flex-pack: end !important;
	justify-content: flex-end !important;
}

.justify-content-center {
	-webkit-box-pack: center !important;
	-ms-flex-pack: center !important;
	justify-content: center !important;
}

.justify-content-between {
	-webkit-box-pack: justify !important;
	-ms-flex-pack: justify !important;
	justify-content: space-between !important;
}

.justify-content-around {
	-ms-flex-pack: distribute !important;
	justify-content: space-around !important;
}

.align-items-start {
	-webkit-box-align: start !important;
	-ms-flex-align: start !important;
	align-items: flex-start !important;
}

.align-items-end {
	-webkit-box-align: end !important;
	-ms-flex-align: end !important;
	align-items: flex-end !important;
}

.align-items-center {
	-webkit-box-align: center !important;
	-ms-flex-align: center !important;
	align-items: center !important;
}

.align-items-baseline {
	-webkit-box-align: baseline !important;
	-ms-flex-align: baseline !important;
	align-items: baseline !important;
}

.align-items-stretch {
	-webkit-box-align: stretch !important;
	-ms-flex-align: stretch !important;
	align-items: stretch !important;
}

.align-content-start {
	-ms-flex-line-pack: start !important;
	align-content: flex-start !important;
}

.align-content-end {
	-ms-flex-line-pack: end !important;
	align-content: flex-end !important;
}

.align-content-center {
	-ms-flex-line-pack: center !important;
	align-content: center !important;
}

.align-content-between {
	-ms-flex-line-pack: justify !important;
	align-content: space-between !important;
}

.align-content-around {
	-ms-flex-line-pack: distribute !important;
	align-content: space-around !important;
}

.align-content-stretch {
	-ms-flex-line-pack: stretch !important;
	align-content: stretch !important;
}

.align-self-auto {
	-ms-flex-item-align: auto !important;
	align-self: auto !important;
}

.align-self-start {
	-ms-flex-item-align: start !important;
	align-self: flex-start !important;
}

.align-self-end {
	-ms-flex-item-align: end !important;
	align-self: flex-end !important;
}

.align-self-center {
	-ms-flex-item-align: center !important;
	align-self: center !important;
}

.align-self-baseline {
	-ms-flex-item-align: baseline !important;
	align-self: baseline !important;
}

.align-self-stretch {
	-ms-flex-item-align: stretch !important;
	align-self: stretch !important;
}

.bg-grey {
	background: var(--light-grey-color);
}


/* text classes */

.text-primary {
	color: var(--primary-color);
}

.text-center {
	text-align: center;
}

.text-right {
	text-align: right;
}

.text-light {
	color: var(--grey-color);
}

.text-dark {
	color: var(--text-dark);
}

.dark-text {
	color: var(--dark-color);
}

.text-white {
	color: var(--white-color);
}

.text-grey {
	color: var(--grey-color);
}

.primary-link,
a.primary-link {
	color: var(--primary-color);
}

.privacy-text .primary-link {
	color: var(--primary-color);
}

.m-0 {
	margin: 0 !important;
}

.mt-0,
.my-0 {
	margin-top: 0 !important;
}

.mr-0,
.mx-0 {
	margin-right: 0 !important;
}

.mb-0,
.my-0 {
	margin-bottom: 0 !important;
}

.ml-0,
.mx-0 {
	margin-left: 0 !important;
}

.m-1 {
	margin: 0.25rem !important;
}

.mt-1,
.my-1 {
	margin-top: 0.25rem !important;
}

.mr-1,
.mx-1 {
	margin-right: 0.25rem !important;
}

.mb-1,
.my-1 {
	margin-bottom: 0.25rem !important;
}

.ml-1,
.mx-1 {
	margin-left: 0.25rem !important;
}

.m-2 {
	margin: 0.5rem !important;
}

.mt-2,
.my-2 {
	margin-top: 0.5rem !important;
}

.mr-2,
.mx-2 {
	margin-right: 0.5rem !important;
}

.mb-2,
.my-2 {
	margin-bottom: 0.5rem !important;
}

.ml-2,
.mx-2 {
	margin-left: 0.5rem !important;
}

.m-3 {
	margin: 1rem !important;
}

.mt-3,
.my-3 {
	margin-top: 1rem !important;
}

.mr-3,
.mx-3 {
	margin-right: 1rem !important;
}

.mb-3,
.my-3 {
	margin-bottom: 1rem !important;
}

.ml-3,
.mx-3 {
	margin-left: 1rem !important;
}

.m-4 {
	margin: 1.5rem !important;
}

.mt-4,
.my-4 {
	margin-top: 1.5rem !important;
}

.mr-4,
.mx-4 {
	margin-right: 1.5rem !important;
}

.mb-4,
.my-4 {
	margin-bottom: 1.5rem !important;
}

.ml-4,
.mx-4 {
	margin-left: 1.5rem !important;
}

.m-5 {
	margin: 3rem !important;
}

.mt-5,
.my-5 {
	margin-top: 3rem !important;
}

.mr-5,
.mx-5 {
	margin-right: 3rem !important;
}

.mb-5,
.my-5 {
	margin-bottom: 3rem !important;
}

.ml-5,
.mx-5 {
	margin-left: 3rem !important;
}

.p-0 {
	padding: 0 !important;
}

.pt-0,
.py-0 {
	padding-top: 0 !important;
}

.pr-0,
.px-0 {
	padding-right: 0 !important;
}

.pb-0,
.py-0 {
	padding-bottom: 0 !important;
}

.pl-0,
.px-0 {
	padding-left: 0 !important;
}

.p-1 {
	padding: 0.25rem !important;
}

.pt-1,
.py-1 {
	padding-top: 0.25rem !important;
}

.pr-1,
.px-1 {
	padding-right: 0.25rem !important;
}

.pb-1,
.py-1 {
	padding-bottom: 0.25rem !important;
}

.pl-1,
.px-1 {
	padding-left: 0.25rem !important;
}

.p-2 {
	padding: 0.5rem !important;
}

.pt-2,
.py-2 {
	padding-top: 0.5rem !important;
}

.pr-2,
.px-2 {
	padding-right: 0.5rem !important;
}

.pb-2,
.py-2 {
	padding-bottom: 0.5rem !important;
}

.pl-2,
.px-2 {
	padding-left: 0.5rem !important;
}

.p-3 {
	padding: 1rem !important;
}

.pt-3,
.py-3 {
	padding-top: 1rem !important;
}

.pr-3,
.px-3 {
	padding-right: 1rem !important;
}

.pb-3,
.py-3 {
	padding-bottom: 1rem !important;
}

.pl-3,
.px-3 {
	padding-left: 1rem !important;
}

.p-4 {
	padding: 1.5rem !important;
}

.pt-4,
.py-4 {
	padding-top: 1.5rem !important;
}

.pr-4,
.px-4 {
	padding-right: 1.5rem !important;
}

.pb-4,
.py-4 {
	padding-bottom: 1.5rem !important;
}

.pl-4,
.px-4 {
	padding-left: 1.5rem !important;
}

.p-5 {
	padding: 3rem !important;
}

.pt-5,
.py-5 {
	padding-top: 3rem !important;
}

.pr-5,
.px-5 {
	padding-right: 3rem !important;
}

.pb-5,
.py-5 {
	padding-bottom: 3rem !important;
}

.pl-5,
.px-5 {
	padding-left: 3rem !important;
}
.p-15{
	padding-left:15px;
	padding-right:15px;
}

/* loader css */


/* Layout */

.center {
	display: block;
	position: absolute;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	margin: auto;
}

.wrapper,
.page-container.loader{
	position: relative;
	width: 100%;
	max-width: 100%;
	height: 100%;
	margin: 0 auto;
	background: rgba(0, 0, 0, 0.05);
}
.page-container.loader:before{
	position: absolute;
	content: "";
	top:0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.5);
	z-index: 99;
}
.loader-2 {
	display: block;
	height: 32px;
	width: 32px;
	-webkit-animation: loader-2-1 3s linear infinite;
	animation: loader-2-1 3s linear infinite;
	z-index: 10000;
}

@-webkit-keyframes loader-2-1 {
	0% {
		-webkit-transform: rotate(0deg);
	}
	100% {
		-webkit-transform: rotate(360deg);
	}
}

@keyframes loader-2-1 {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}

.loader-2 span {
	display: block;
	position: absolute;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	margin: auto;
	height: 32px;
	width: 32px;
	clip: rect(16px, 32px, 32px, 0);
	-webkit-animation: loader-2-2 1.5s cubic-bezier(0.770, 0.000, 0.175, 1.000) infinite;
	animation: loader-2-2 1.5s cubic-bezier(0.770, 0.000, 0.175, 1.000) infinite;
}

@-webkit-keyframes loader-2-2 {
	0% {
		-webkit-transform: rotate(0deg);
	}
	100% {
		-webkit-transform: rotate(360deg);
	}
}

@keyframes loader-2-2 {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}

.loader-2 span::before {
	content: "";
	display: block;
	position: absolute;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	margin: auto;
	height: 32px;
	width: 32px;
	border: 3px solid transparent;
	border-top: 3px solid #FFF;
	border-radius: 50%;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
	-webkit-animation: loader-2-3 1.5s cubic-bezier(0.770, 0.000, 0.175, 1.000) infinite;
	animation: loader-2-3 1.5s cubic-bezier(0.770, 0.000, 0.175, 1.000) infinite;
}

@-webkit-keyframes loader-2-3 {
	0% {
		-webkit-transform: rotate(0deg);
	}
	100% {
		-webkit-transform: rotate(360deg);
	}
}

@keyframes loader-2-3 {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}

.loader-2 span::after {
	content: "";
	display: block;
	position: absolute;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	margin: auto;
	height: 32px;
	width: 32px;
	border: 3px solid rgba(44, 151, 222, 1);
	border-radius: 50%;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
}


/* panel css */

.panel {
	position: relative;
	display: flex;
	flex-direction: column;
	background: var(--white-color);
	border-radius: 5px;
	box-shadow: 0px 13px 26px rgba(0, 0, 0, 0.07);
}
.panel.no-shadow{
	box-shadow:none;
}
.panel-bordered {
	border: 1px solid #e6e6e6;
	box-shadow: none;
}

.panel-header {
	position: relative;
	background: var(--grey-shade);
	padding: 0.875rem;
	margin: 0.25rem;
	border-radius: 5px 5px 0px 0px;
}
.panel-primary .panel-header{
	background: var(--primary-color);
	color: #fff;
	position:relative;
}
.price-drop-panel .panel-header .btn-rounded{
	width: 1.5rem;
	height: 1.5rem;
	border-radius: 50%;
	display: flex;
	justify-content: center;
	align-items: center;
	color: var(--primary-color);
	padding: 0 0.125rem;
	position:absolute;
	right:0.75rem;
	top:0.875rem;
}
.panel-header .btn-rounded i.icon-minus{
	font-size: 0.175rem;
}
.panel-header h3 {
	font-size: 1.2875rem;
	font-weight: 500;
	line-height: normal;
	display:flex;
	align-items:center;
	margin-bottom:0.5rem !important;
}
.panel-header h3 i{
	cursor:pointer;
}
.panel-body {
	padding: 0.75rem 1.2rem;
}
.panel-body ~ .panel{
	padding-left:5px;
	padding-right:5px;
}
.panel-footer {
	display: flex;
	justify-content: flex-end;
	padding: 1.5rem;
	border-top: 1px solid #e6e6e6;
}

.panel-footer .btn+.btn {
	margin-left: 0.5rem;
}

.reminder-panel {
	border: 1px solid #e6e6e6;
	border-radius: 10px;
	overflow: hidden;
}

.reminder-panel select.form-control {
	font-size: 0.875rem;
	padding: 0.25rem;
}

.reminder-panel+.reminder-panel {
	margin-top: 2rem;
}

.reminder-panel .panel-header {
	background: var(--white-color);
}

.reminder-panel .panel-body {
	padding: 1rem 0.5rem 1.5rem;
	border-top: 1px solid #e6e6e6;
	background: var(--grey-shade);
}

.price-drop-panel {
	width:380px;
	margin: 0 15px;
}

.price-drop-panel h6{
	font-size:1.125rem;
} 
.price-drop-panel p{
	font-size: 0.875rem;
	padding: 0 1rem;
}
.price-drop-panel .btn{
	font-size:0.875rem;
	padding: 0.35rem 1.875rem;
}
/* tabs css */

.tabs-list a {
	display: inline-block;
	font-size: 0.75rem;
	background: var(--white-color);
	padding: 0.75rem 1rem;
	text-decoration: none;
	color: var(--text-dark);
	font-weight: var(--font-semi-bold);
}

.tabs-list a+a {
	margin-left: -4px;
}

.tabs-list a:first-child {
	border-radius: 5px 0px 0px 0px;
}

.tabs-list a:last-child {
	border-radius: 0px 5px 0px 0px;
}

.tabs-list a.active {
	background: var(--primary-color);
	color: var(--white-color);
}

.tabs-header {
	display: flex;
	flex-wrap: wrap;
	background: var(--grey-shade);
}

.horizontal-tabs {
	display: none;
	justify-content: center;
	position: relative;
}

.horizontal-tabs:before {
	position: absolute;
	content: "";
	bottom: 0;
	left: 0;
	right: 0;
	background: #e6e6e6;
	height: 1px;
}

.horizontal-tabs .tabs-content {
	border-top: 1px solid #e6e6e6;
	padding: 15px;
}

.horizontal-tabs a {
	color: var(--text-dark);
	text-decoration: none;
	border-top: 1px solid #E6E6E6;
	border-left: 1px solid #e6e6e6;
	padding: 0.5rem 1.25rem;
	display: inline-block;
	font-size: 0.875rem;
}

.horizontal-tabs a:last-child {
	border-right: 1px solid #e6e6e6;
	border-top-right-radius: 0.45rem;
}

.horizontal-tabs a:first-child {
	border-top-left-radius: 0.45rem;
}

.horizontal-tabs a:hover {
	background: var(--primary-color);
	color: var(--white-color);
}

.horizontal-tabs a.active {
	background: var(--primary-color);
	color: var(--white-color);
}


/* accordion css */

.accordion {
	background: var(--white-color);
	border: 1px solid #E6E6E6;
	border-radius: 5px;
	margin-bottom: 1rem;
	overflow: hidden;
}

.accordion-title {
	padding: 0.875rem;
	border-bottom: 1px solid #E6E6E6;
}

.accordion-body {
	padding: 0.5rem;
}

.accordion.collapse>.accordion-body {
	padding: 0;
	height: 0;
	margin-top: -1px;
	overflow: hidden;
	animation: all 0.5ms ease-in-out 0.5ms;
}
.accordion-title .media_body p{
	white-space: normal;
	word-break: break-all;
	font-size:12px;
}
.accordion-title .media_figure{
	min-width:40px;
}
/* table css */

.table-responsive {
	display: block;
	width: 100%;
	overflow-x: auto;
	-webkit-overflow-scrolling: touch;
	-ms-overflow-style: -ms-autohiding-scrollbar;
}

.table {
	width: 100%;
	max-width: 100%;
	margin-bottom: 1rem;
	background-color: transparent;
}

.table th,
.table td {
	padding: 0.45rem 0.75rem;
	vertical-align: middle;
	border-top: 1px solid var(--grey-shade);
}
.table th{
	position:sticky;
	top:0;
	z-index:4;
	background: var(--grey-shade);
}
.table td {
	font-size: 1rem;
	color: var(--grey-color);
}

.table-responsive {
	border-radius: 5px;
	margin-bottom: 1rem;
}

.table thead th {
	vertical-align: bottom;
	border-bottom: 2px solid var(--grey-shade);
	color: #253858;
	font-weight: var(--font-medium);
}
.table thead tr:nth-child(2) th{
	top:52px;
}
.campaigns-report-table thead tr:first-child th{
	background:#fff;
}
.topics-table td .toggle-control,
.permissions-table td .toggle-control{
	margin-bottom:1rem;
}
.table tbody+tbody {
	border-top: 2px solid #dee2e6;
}

.table .table {
	background-color: #fff;
}

.table-sm th,
.table-sm td {
	padding: 0.3rem;
}

.table-bordered {
	border: 1px solid #dee2e6;
}

.table-bordered th,
.table-bordered td {
	border: 1px solid #dee2e6;
}

.table-bordered thead th,
.table-bordered thead td {
	border-bottom-width: 2px;
}

.table-striped tbody tr:nth-of-type(odd) {
	background-color: rgba(0, 0, 0, 0.05);
}

.table-hover tbody tr:hover {
	background-color: var(--grey-shade);
	cursor: pointer;
}

.map-table thead th {
	background: #fff;
	border: 0;
}

.map-table tbody {
	border: 1px solid #e6e6e6;
}

.map-table tbody td {
	border-top-color: #E6E6E6;
}

.graph-container img,
.map-container img {
	max-width: 100%;
	width: 100%;
	height: auto;
}

.close-btn {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 1.75rem;
	margin: 0.5rem;
	padding: 2px;
}


/* toggle button */

.toggle-control {
	display: inline-block;
	position: relative;
	margin-bottom: 0;
	cursor: pointer;
	font-size: 1.125rem;
	margin-right: 1rem;
	min-width: 9rem;
	margin-bottom: 1.5rem;
	color: var(--grey-color);
	font-weight: var(--font-regular);
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

.toggle-control-xs {
	min-width: 2rem;
	max-width: 2rem;
}

.toggle-control-sm {
	min-width: 3rem;
	max-width: 3rem;
	height:20px;
}

.toggle-control-md {
	min-width: 15rem;
}

.toggle-control input {
	position: absolute;
	opacity: 0;
	cursor: pointer;
	height: 0;
	width: 0;
}

.toggle-control input:checked~.control {
	background-color: #83B547;
}

.toggle-control input:checked~.control:after {
	left: 29px;
}

.toggle-control-xs input:checked~.control:after {
	left: 22px;
}

.toggle-control-sm input:checked~.control:after {
	left: 24px;
}
.toggle-control-md input:checked~.control:after {
	left: 29px;
}

.toggle-control .control {
	position: absolute;
	top: 0;
	right:0;
	height: 22px;
	width: 50px;
	border-radius: 25px;
	background-color: darkgray;
	transition: background-color 0.15s ease-in;
}

.toggle-control-xs .control {
	width: 40px;
	height: 20px;
}

.toggle-control-sm .control {
	width: 45px;
	height: 22px;
}

.toggle-control .control:after {
	content: "";
	position: absolute;
	left: 1px;
	top: 1px;
	width: 20px;
	height: 20px;
	border-radius: 25px;
	background: white;
	transition: left 0.15s ease-in;
}

.toggle-control-xs .control:after {
	width: 16px;
	height: 16px;
	border-radius: 20px;
	left: 2px;
	top: 2px;
}

.toggle-control-sm .control:after {
	width: 18px;
	height: 18px;
	border-radius: 20px;
	left: 2px;
	top: 2px;
}


/* custom checkbox */

.custom-control {
	position: relative;
	z-index: 1;
	display: block;
	min-height: 1.5rem;
	padding-left: 1.5rem;
	-webkit-print-color-adjust: exact;
	color-adjust: exact;
}
.custom-checkbox .custom-control-label {
	font-size: 0.875rem;
	line-height: 2;
	cursor: pointer;
}

.custom-radio .custom-control-label {
	font-size: 0.875rem;
	line-height: 2;
	cursor: pointer;
}

.custom-control-input {
	position: absolute;
	z-index: -1;
	opacity: 0;
	cursor: pointer;
}

.custom-checkbox .custom-control-input:checked~.custom-control-label::before {
	background-color: #007bff;
}

.custom-checkbox .custom-control-input:checked~.custom-control-label::after {
	background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E");
}

.custom-checkbox .custom-control-input:indeterminate~.custom-control-label::before {
	background-color: #007bff;
}

.custom-checkbox .custom-control-input:indeterminate~.custom-control-label::after {
	background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 4'%3E%3Cpath stroke='%23fff' d='M0 2h4'/%3E%3C/svg%3E");
}

.custom-checkbox .custom-control-input:disabled:checked~.custom-control-label::before {
	background-color: rgba(0, 123, 255, 0.5);
}

.custom-checkbox .custom-control-input:disabled:indeterminate~.custom-control-label::before {
	background-color: rgba(0, 123, 255, 0.5);
}

.custom-radio .custom-control-label::before {
	border-radius: 50%;
}

.custom-radio .custom-control-input:checked~.custom-control-label::before {
	background-color: #007bff;
}

.custom-radio .custom-control-input:checked~.custom-control-label::after {
	background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='%23fff'/%3E%3C/svg%3E");
	top: -1px;
    left: -24px;
    width: 22px;
    height: 22px;
}

.custom-radio .custom-control-input:disabled:checked~.custom-control-label::before {
	background-color: rgba(0, 123, 255, 0.5);
}

.custom-control-label {
	position: relative;
	margin-bottom: 0;
	vertical-align: top;
}

.custom-control-label::before {
	position: absolute;
	top: 4px;
	left: -20px;
	display: block;
	width: 15px;
    height: 15px;
	pointer-events: none;
	content: "";
	background-color: #fff;
	border: #adb5bd solid 1px;
}

.custom-control-label::after {
	position: absolute;
	top: 5px;
	left: -19px;
	display: block;
	width: 15px;
	height: 15px;
	content: "";
	background-repeat: no-repeat;
	background-position: center center;
	background-size: 50% 50%;
}

.custom-checkbox .custom-control-label::before {
	border-radius: 0.25rem;
}

.custom-checkbox .custom-control-input:checked~.custom-control-label::before {
	background-color: #007bff;
}

.custom-checkbox .custom-control-input:checked~.custom-control-label::after {
	background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E");
}

.custom-checkbox .custom-control-input:indeterminate~.custom-control-label::before {
	background-color: #007bff;
}

.custom-checkbox .custom-control-input:indeterminate~.custom-control-label::after {
	background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 4'%3E%3Cpath stroke='%23fff' d='M0 2h4'/%3E%3C/svg%3E");
}

.custom-checkbox .custom-control-input:disabled:checked~.custom-control-label::before {
	background-color: rgba(0, 123, 255, 0.5);
}

.custom-checkbox .custom-control-input:disabled:indeterminate~.custom-control-label::before {
	background-color: rgba(0, 123, 255, 0.5);
}

.toggle-btn {
	position: relative;
	border: 0;
	background: transparent;
	width: 40px;
	height: 30px;
	display: flex;
	align-items: center;
	cursor: pointer;
	z-index: 5;
}

.toggle-btn span {
	position: relative;
	width: 100%;
	background: var(--text-dark);
	height: 3px;
	display: inline-block;
}

.toggle-btn span:before,
.toggle-btn span:after {
	position: absolute;
	content: "";
	top: -7px;
	left: 0;
	background: var(--text-dark);
	height: 3px;
	width: 100%;
}

.toggle-btn span:after {
	top: auto;
	bottom: -7px;
}


/* login page css */

.login-container {
	width: 100%;
	margin: 0 auto;
	padding: 2rem;
}

.logo-container {
	max-width: 100%;
	margin: 0 auto 2rem;
}

.login-container .anchor-none:hover {
	color: var(--text-dark);
}

.logo-container img {
	max-width: 13rem;
}

.bg-login {
	position: relative;
	background: var(--primary-color);
}

.bg-login:before,
.bg-login:after {
	position: absolute;
	content: "";
	left: 0;
	top: 0;
	background: url(../images/Vector.png) no-repeat;
	background-size: contain;
	min-height: 14rem;
	width: 100%;
}

.bg-login:after {
	top: auto;
	bottom: 0;
	right: 0;
	left: auto;
	background: url(../images/Union.png) no-repeat;
	background-size: contain;
	background-position: right bottom;
	min-height: 20rem;
}

.bg-login img {
	max-width: 35rem;
}

.login-tile {
	position: relative;
}

.login-tile .avatar {
	width: 3.5rem;
	height: 3.5rem;
	display: flex;
	align-items: center;
	justify-content: center;
	background: var(--white-color);
	border-radius: 50%;
	position: absolute;
}

.login-tile .avatar img {
	max-width: 1.75rem;
	width: 100%;
	height: auto;
}

.joomla-avatar {
	bottom: -92px;
	left: 30px;
}

.glass-avatar {
	right: 45px;
	bottom: -11px;
	z-index: 5;
}

.logo-container-sm {
	display: inline-block;
	width: 100%;
	text-align: center;
	padding: 0rem 0.5rem;
	position: absolute;
	left: 0;
	right: 0;
	top: 15px;
	z-index: 4;
	/* border-bottom: 1px solid #E6E6E6; */
}

.logo-container-sm img {
	max-width: 10rem;
}

header {
	padding: 0.75rem 1rem;
	z-index: 5;
	box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
}

.btn.toggle-btn-rounded {
	position: absolute;
	content: "";
	top: 38px;
	border-radius: 50%;
	z-index: 9999;
	right: -10px;
	width: 24px;
	height: 24px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 0.75rem;
	background: #fff;
	padding: 0;
	line-height: 1;
	border-color: #E6E6E6;
	box-shadow: none;
}

.toggle-aside .toggle-btn-rounded i {
	transform: rotate(-180deg);
}

.toggle-aside .navigation-menu .dropdown-menu {
	padding-left: 0;
	margin: 0.5rem 0;
	border-radius: 0.25rem;
	overflow: hidden;
}

.toggle-aside .navigation-menu .dropdown-menu a {
	font-size: 0.975rem;
	padding: 0.5rem 1rem;
	display: inline-block;
	width: 100%;
}

.toggle-aside .navigation-menu .dropdown-menu a:hover {
	background: var(--primary-color);
	color: var(--white-color);
}

.toggle-aside .navigation-menu li:hover .dropdown-menu {
	position: absolute;
	display: block;
	top: 0;
	left: 80px;
	min-width: 12rem;
	height: auto;
	border: 1px solid #e6e6e6;
}

.toggle-aside aside {
	min-width: 80px;
	max-width: 80px;
}

.toggle-aside aside .scrollable_y {
	overflow: unset;
}

.toggle-aside .sub-menu {
	display: none;
}

.custom-select {
	position: relative;
}
.custom-select .css-1s2u09g-control{
	height:33px;
	min-height:33px;
}
.custom-control .css-1527cbq-menu{
	z-index:8;
}
.custom-select-icon .form-control {
	padding-left: 2rem;
	padding-right: 1rem;
}

.custom-select i {
	position: absolute;
	content: "";
	top: 9px;
	left: 8px;
}

header .dropdown-menu {
	top: 90%;
}

header .dropdown-notch {
	position: absolute;
	right: 10px;
	top: -9px;
	width: 0;
	height: 0;
	border-left: 7px solid transparent;
	border-right: 5px solid transparent;
	border-bottom: 10px solid #fff;
}

.btn-toggle {
	background: transparent;
	box-shadow: none;
	border: 0;
}

.btn-toggle:before,
.btn-toggle:after {
	position: absolute;
	content: "";
	width: 100%;
	height: 2px;
	background: var(--grey-color);
}

.dropdown {
	position: relative;
	z-index: 6;
}

.dropdown-menu {
	position: absolute;
	top: 100%;
	left: auto;
	right: 0;
	z-index: 1000;
	display: none;
	float: left;
	min-width: 13rem;
	padding: 0.5rem 0;
	margin: 0.125rem 0 0;
	font-size: 1rem;
	color: #212529;
	text-align: left;
	list-style: none;
	background-color: #fff;
	background-clip: padding-box;
	border: 1px solid rgba(0, 0, 0, 0.15);
	border-radius: 0.25rem;
}

.dropdown-item {
	color: var(--text-dark);
	font-weight: var(--font-regular);
	border: 0;
	display: flex;
	align-items: center;
	width: 100%;
	text-align: left;
	background: transparent;
	padding: 0.5rem 0.875rem;
	cursor: pointer;
}

.dropdown-item i {
	margin-right: 0.65rem;
}

.dropdown-menu.show {
	display: block;
}

.profile-avatar {
	width: 2.5rem;
	height: 2.5rem;
	border-radius: 50%;
}
.profile-avatar + .dropdown .btn.dropdown-toggle{
	border:0;
}
.dropdown-toggle {
	position: relative;
	display: flex;
	flex-direction: column;
	background-color: transparent;
	min-width: 2rem;
}

.dropdown-toggle:before {
	position: absolute;
	content: "";
	top: 15px;
	right: 0;
	width: 0;
	height: 0;
	border-left: 6px solid transparent;
	border-right: 6px solid transparent;
	border-top: 9px solid var(--grey-color);
	display: none;
}

.dropdown-item:hover {
	background: #F1F2F3;
}

.dropdown-toggle span {
	font-size: 0.975rem;
	margin-right: 10px;
}

.dropdown-toggle span:nth-child(2) {
	font-size: 0.875rem;
	color: var(--primary-color);
}

.dropdown-toggle .icon-profile {
	font-size: 1.5rem;
}

.profile-avatar img {
	width: 100%;
	height: 100%;
}

.navigation-menu {
	position: relative;
}

.navigation-menu .dropdown-menu {
	position: relative;
	display: none;
	flex-direction: column;
	border: 0;
	padding: 0;
	padding-left: 3rem;
	min-width: 12rem;
	width: 100%;
	border: 0;
	float: none;
	margin: 0rem;
	height: 0;
	animation: height 3ms ease-in-out 5ms;
}

.navigation-menu .open-dropdown .dropdown-menu {
	display: flex;
	height: 100%;
}

.navigation-menu>li>a {
	display: flex;
	align-items: center;
	padding: 0.75rem 0.75rem 0.75rem 0.25rem;
	text-decoration: none;
	color: var(--text-dark);
	/*width: calc(100% - 10px);*/
	border: 3px solid transparent;
	margin-left: 0.5rem;
	border-radius: 5px 0 0 5px;
	font-weight: var(--font-medium);
	cursor:pointer;
}

.toggle-aside .navigation-menu>li>a {
	/* white-space: nowrap;
    overflow:hidden; */
}

.toggle-aside .navigation-menu>li>a span {
	display: none;
}

.navigation-menu>li>a:hover {
	text-decoration: none;
}

.navigation-menu>li>a:hover,
.navigation-menu>li>a:focus {
	border-left-color: var(--primary-color);
	background: var(--grey-shade);
	color: var(--primary-color);
}

.navigation-menu>li.active>a,
.navigation-menu>li.active>a:hover,
.navigation-menu>li.active>a i {
	border-left-color: var(--primary-color);
	background: var(--grey-shade);
	color: var(--primary-color);
}

.navigation-menu>li>a i {
	margin: 0 0.875rem 0 0.75rem;
}

.toggle-aside .logo-container-sm .logo-md {
	display: none;
}

.logo-container-sm .logo-sm {
	display: none;
}

.toggle-aside .logo-container-sm .logo-sm {
	display: flex;
}

.toggle-aside .logo-container-sm img {
	max-width: 3rem;
	margin: 0 auto;
}

.navigation-menu .icon-arrow-up,
.navigation-menu .icon-arrow-down {
	position: absolute;
	right: 5px;
	color: #647482;
}

.navigation-menu .icon-arrow-up:before {
	font-size: 0.75rem;
}

.navigation-menu .icon-arrow-down:before {
	font-size: 0.5rem;
}

.navigation-menu .dropdown-menu>a {
	font-weight: var(--font-regular);
	color: var(--grey-color);
	padding: 0.45rem 0 0.45rem 0.5rem;
	text-decoration: none;
	cursor:pointer;
	border-left: 3px solid transparent;
	position:relative;
}
.navigation-menu .dropdown-menu>a:before{
	position:absolute;
	content:"";
	left:0;
	width:2px;
	height:calc(100% - 14px);
	background:transparent;
}
.navigation-menu .dropdown-menu>a.active:before{
	background:var(--primary-color);
}
.navigation-menu .dropdown-menu>a.active {
	color: var(--primary-color);
}
.navigation-menu li {
	position: relative;
	padding:7px 0 7px 0;
}
.navigation-menu li:not(:last-child) {
	border-bottom: 1px solid #e6e6e6;
}
.navigation-menu li.open-dropdown > a{
	background:#F4F5F6;
	font-weight:semi-bold;
	color:#253858;
}
.list-unstyled {
	list-style: none;
	margin: 0;
	padding: 0;
}

aside {
	position: fixed;
	background: #fff;
	z-index: 999;
	min-width: 80vw;
	max-width: 80vw;
	box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
	transform: translateX(-100%);
	animation: transform 0.3ms ease-in-out 0.5ms;
}

.open-nav aside {
	z-index: 20;
	transform: translateX(0);
	animation: transform 0.3ms ease-in-out 0.5ms;
}

.open-nav {
	position: relative;
}

.open-nav:before {
	position: absolute;
	content: "";
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, .5);
	z-index: 18;
}

.page-container {
	background: var(--grey-shade);
	padding: 1.5rem;
	/* padding-top:70px; */
}

.card {
	padding: 10px;
	border-radius: 5px;
	box-shadow: 0px 13px 25px rgba(0, 0, 0, 0.07);
	background: #fff;
}

.card-header {
	background: var(--grey-shade);
	padding: 8px;
}

.card-body {
	padding: 1rem;
}

.media {
	display: flex;
}

.media_figure {
	margin-right: 1rem;
}

.media_figure.media-sm{
	min-width:40px;
}

.media-center {
	align-items: center;
}

.media_rounded {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 3.5rem;
	height: 3.5rem;
	border-radius: 50%;
}

.media_rounded .avatar i {
	color: #fff;
	line-height: 2.5rem;
	font-size: 1.5rem;
}

[data-campaign-status="sent"] {
	background: #2C97DE;
}

[data-campaign-status="subscribers"] {
	background: #83B547;
}

[data-campaign-status="consumed"] {
	background: #EDBD45;
}

[data-campaign-status="warning"] {
	background: var(--warning-color);
}


/* notification css */

.notification-wrapper {
	background: var(--white-color);
	padding: 0.875rem;
	box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.15);
	border-radius: 5px;
}
.notification-wrapper .banner-image{
	max-width:100%;
	height: auto;
}
.notification-wrapper .title {
	font-size: 0.75rem;
	font-weight: var(--font-regular);
	margin-bottom: 0.5rem;
}

.notification-wrapper .title .btn {
	padding: 0;
}

.notification-wrapper+.btn {
	padding: 0.25rem 0.5rem;
}
.notification-wrapper .btn{
	padding-left: 0;
	padding-right: 0;
}
.notification-icon {
	min-width: 4.5rem;
	max-width: 4.5rem;
	height: 100%;
	/* margin-left: 1rem; */
}

.notification-icon img {
	width: 100%;
	height: 100%;
}
.notification-wrapper .description {
	font-size: 0.75rem;
	font-weight: var(--font-thin);
	padding-left: 1rem;
}
.description-title{
	margin-top: 0.5rem;
	font-size: 0.9rem;
	font-weight: 500;
}
.custom-description{
	font-family: Arial,sans-serif;
	padding:0 15px 15px 0px;
	word-break:break-word;
}
.prompt-alert[data-alert="popup"] description{
	padding:15px;
}
.custom-description h6,
.prompt-alert h6{
	font-family: Arial,sans-serif;
	font-size:1rem;
	font-weight:400;
	word-break: break-word;
}
.custom-description > p{
	font-family: Arial,sans-serif;
	font-size: 0.875rem;
	word-break: break-word;
}
.custom-description > p > small, .prompt-alert small, .prompt-alert h5, .custom-description .btn {
	font-family: Arial,sans-serif;
}

.break-heading{
	word-break: break-word;	
}

.description p{
	font-size: 0.875rem;
	word-break: break-all;
    text-overflow: ellipsis;
    overflow: hidden;
	display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
}
.description h3{
	word-break: break-all;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}
.color-p {
	color: #e6e6e6 !important;
}
.width-full{
	width: 100%;
}
.width-80 {
	width: 80%;
}
.width-50 {
	width: 50%;
}
.width-60 {
	width: 60%;
}
.pd-0 {
	padding: 0;
}

.gap-25 {
	gap: 0.25rem;
}

.gap-1 {
	gap: 1rem;
}

.gap-2 {
	gap: 2rem;
}
.notification-wrapper .link {
	text-decoration: none;
	color: var(--grey-color);
}
.filter-image{
	filter: grayscale(100%);
	width:15px;
	height: auto;
}
[data-platform="windows"]{
	background:rgba(0,0,0,.87);
}
[data-platform="windows"] .description-title,
[data-platform="windows"] .description,
[data-platform="windows"] .title{
	color: var(--white-color);
}

[data-platform="windows"] .notification-icon{
	min-width:2rem;
	max-width:2rem;
	height: 2rem;
	margin:0.5rem 1rem 0 0;
}
[data-platform="windows"] .action-btn,
[data-platform="windows10"] .action-btn{
	background: #6b6b6b;
	color:var(--white-color);
	border-radius: 5px;
	min-width: 46%;
	font-size: 1rem;	
	margin: 1rem 0.25rem 0.5rem;
}
[data-platform="windows-firefox"] .notification-icon{
	min-width: 3.5rem;
    max-width: 3.5rem;
    height: auto;
    margin: 0;
    margin-right: 1rem;
}
[data-platform="windows-firefox"] .description-title{
	font-weight: var(--font-bold);
}
[data-platform="windows-firefox"] .close-btn{
	font-size: 0.75rem;
    padding: 0;
    margin: 0;
	width:auto;
}
[data-platform="macos"]{
	background: #ececed;
	box-shadow: 0 0 0.625rem rgb(0 0 0 / 24%);
	border-radius: 0.625rem;
	position: relative;
	overflow: hidden;
	cursor: pointer;
}
[data-platform="macos"] .notification-icon{
	min-width: 3.5rem;
    max-width: 3.5rem;
    height: auto;
    margin: 0 1rem 0 0;
}
[data-platform="macos"] .secondary-action{
	min-width: 4.5rem;
	max-width: 4.5rem;
	height: 4.5rem;
	margin-right: 0;
}
[data-platform="macos"] .description-title{
	font-size: 0.9375rem;
	color: #39393a;
	margin-top: 0;
}
[data-platform="macos"] .description-text{
	color: #676767;
	font-size: 0.84375rem;
}
[data-platform="macos"] .title{
	font-weight: var(--font-bold);
}
[data-platform="macos"]:hover .action-buttons{
	transform: translateX(0%);
	animation: width 500ms ease-in-out 500ms;
} 
[data-platform="macos"] .action-buttons{
	display: flex;
	flex-direction: column;
	position: absolute;
	top:0;
	bottom: 0;
	right: 0;
	left: auto;
	text-align: center;
	border-radius: 0 0.625rem 0.625rem 0;
    background-color: rgba(236,236,237,.98);
    border-left: 0.0625rem solid #d2d2d2;
	color: #6a6b6b;
	transform: translateX(100%);
}
[data-platform="macos"] .action-buttons span{
	padding:0.75rem 1rem;
}
[data-platform="macos"] .action-buttons span + span{
	border-top:1px solid #d2d2d2;
}

/* progress bars */

.progress {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	height: 0.5rem;
	overflow: hidden;
	font-size: 0.75rem;
	background-color: #e9ecef;
	border-radius: 0.5rem;
}

.progress-bar {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-ms-flex-direction: column;
	flex-direction: column;
	-webkit-box-pack: center;
	-ms-flex-pack: center;
	justify-content: center;
	color: #fff;
	text-align: center;
	background-color: #007bff;
	transition: width 0.6s ease;
}

.bg-mozilla {
	background-color: #EDBD45;
}

.bg-chrome {
	background-color: var(--warning-color);
}

.bg-apple {
	background-color: #2C97DE;
}

.bg-success {
	background-color: rgb(25, 135, 84);
}

.txt-success {
	color: rgb(25, 135, 84);
}

.bg-desktop {
	background: #83B547;
}

.bg-tablet {
	background: #253858;
}

.bg-mobile {
	background: #2C97DE;
}

.text-desktop {
	color: #83B547;
}

.text-tablet {
	color: #253858;
}

.text-mobile {
	color: #2C97DE;
}

.round-indicator {
	position: relative;
	padding-left: 1.5rem;
}

.round-indicator:before {
	position: absolute;
	width: 0.5rem;
	height: 0.5rem;
	border: 3px solid #2C97DE;
	content: "";
	border-radius: 50%;
	left: 0;
	top: 5px;
	box-shadow: 0px 4px 4px rgb(44 151 222 / 30%);
}

.feature-card {
	padding: 1.5rem;
}

.feature-card .range-count {
	font-size: 1.25rem;
}

.increment-icon,
.decrement-icon,
.increment-icon-sm,
.decrement-icon-sm {
	display: inline-block;
	width: 0;
	height: 0;
	border-left: 7px solid transparent;
	border-right: 7px solid transparent;
	border-bottom: 10px solid #647482;
}

.increment-icon-sm,
.decrement-icon-sm {
	border-left-width: 5px;
	border-right-width: 5px;
	border-bottom-width: 8px;
}

.increment-icon.default,
.decrement-icon.default {
	border-bottom-color: #647482;
}

.decrement-icon {
	transform: rotate(-180deg);
	animation: transform 0.5ms ease-in-out 0.5ms;
}

.increment-icon {
	border-bottom: 10px solid #83B547;
}

.decrement-icon {
	transform: rotate(-180deg);
	border-bottom-color: var(--warning-color);
}

.feature-card h2 {
	font-size: 3rem;
}

.action-buttons button {
	min-width: 48%;
	margin-bottom: 0.75rem;
}

.action-buttons button i {
	margin-right: 0.25rem;
}

.preview-section {
	position: relative;
	background: url('../images/pngwing.svg') no-repeat;
	background-size: cover;
	min-height: 250px;
	max-width: 100%;
	width: 95%;
	height: 100%;
	background-position: -15px center;
}

.preview-section .box {
	position: absolute;
	content: "";
	top: 35%;
	left: 10%;
	max-width: 80%;
	box-shadow: 0px 4px 14px rgb(0 0 0 / 15%);
	backdrop-filter: blur(4px);
	border-radius: 10px;
}

.error-container {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}

.error-container .description {
	max-width: 100%;
	text-align: center;
}

.error-container img {
	max-width: 100%;
	height: 45vh;
}

code {
	font-family: monospace;
}

.plugin-wrapper .img-md {
	max-width: 100%;
	height: 8rem;
}

.plugin-wrapper .img-sm {
	max-width: 100%;
	height: 3rem;
}

.plugin-wrapper h5 {
	font-size: 1rem;
}

.plugin-wrapper p {
	font-size: 0.975rem;
	line-height: normal;
}

.custom-select-xs {
	min-width: 6rem;
	max-width: 6rem;
	font-size: 0.875rem;
}

.custom-select-sm {
	min-width: 8rem;
	max-width: 12rem;
	font-size: 0.875rem;
}

.custom-select-md {
	min-width: 12rem;
	max-width: 12rem;
}

.btn-toggle {
	display: block;
}

.add-segment-wrapper {
	padding: 0.25rem;
	background: var(--white-color);
	border-radius: 5px;
	box-shadow: 0px 13px 26px rgb(0 0 0 / 7%);
}

.add-segment-wrapper .panel {
	border-radius: 0;
	box-shadow: none;
}

.add-segment-wrapper .panel-header {
	margin: 0;
	border-radius: 0;
}

.add-segment-wrapper .filter-panel {
	border: 0;
	border-radius: 5px;
}

.add-segment-wrapper .reminder-panel {
	border-radius: 10px;
}

.filter-feature:nth-child(2) {
	border-top: 1px solid #e6e6e6;
	border-bottom: 1px solid #e6e6e6;
}

.segments-tabs .accordion {
	margin: 1rem 0;
}

.banner-placeholder {
	max-width: 24rem;
	width: 100%;
	height: 14rem;
}

.banner-placeholder img {
	max-width: 100%;
	height: auto;
}


/* prompt css */

.preview-container {
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	background: rgba(0, 0, 0, 0.3);
	overflow: hidden;
}

.prompt-container {
	position: relative;
	display: inline-block;
	cursor: pointer;
	width: 100%;
	border-radius: 3px;
}

.prompt-container.active .content-box {
	border-color: var(--primary-color);
}

.prompt-container.active .title {
	color: var(--primary-color);
}

.prompt-container .content-box {
	display: flex;
	position: relative;
	width: 100%;
	height: 7rem;
	background: var(--grey-shade);
	border: 1px solid #E6E6E6;
	padding: 3px;
	border-radius: inherit;
}

.prompt-notification{
	animation: bell 2s ease 0s 1 normal forwards;
}

.content-box[data-prompt-mobile] {
	background: var(--white-color);
}

.content-box[data-prompt-mobile] .prompt {
	background: #F4F5F6;
	width: 50%;
	margin: 0 auto;
}

[data-prompt-mobile] .prompt div,
[data-prompt-mobile="slideup"] .prompt div,
[data-prompt-mobile="popup"] .prompt div {
	width: 100%;
	height: 15px;
	background: rgba(100, 116, 130, 0.2);
}

[data-prompt-mobile="popup"] .prompt div {
	height: 30px;
}

[data-prompt-mobile="right-sticky"] .prompt div {
	width: 10px;
	height: 40%;
}

[data-prompt-mobile="notification"] .prompt div {
	width: 15px;
	height: 15px;
	border-radius: 50%;
	margin: 0.5rem;
}

[data-prompt-mobile="overlay"] .prompt div {
	width: 100%;
	height: 100%;
}

.prompt-container .content-box:before {
	position: absolute;
	content: "";
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	border: 3px solid #fff;
	border-radius: inherit;
}

.prompt-container .title {
	font-size: 0.75rem;
	text-align: center;
	margin-bottom: 0.25rem;
}

.prompt-container .custom-checkbox {
	position: absolute;
	top: 25px;
	right: 2px;
}

.prompt-container .custom-checkbox .custom-control-label::before {
	border-radius: 50%;
	cursor: pointer;
}

.prompt {
	display: flex;
	background: rgba(100, 116, 130, 0.2);
}

.prompt-header,
.prompt-footer {
	position: absolute;
	top: 3px;
	width: calc(100% - 6px);
	height: 10px;
}

.prompt-footer {
	top: auto;
	bottom: 3px;
}

[data-prompt="popup"] {
	justify-content: center;
	align-items: center;
}

[data-prompt="message-box"] {
	align-items: flex-end;
	justify-content: flex-end;
}

[data-prompt="message-box"] .prompt {
	width: 3rem;
	height: 0.75rem;
}

[data-prompt="popup"] .prompt-center {
	width: 2rem;
	height: 2rem;
}

[data-prompt="top-sticky"] {
	align-items: flex-start;
}

[data-prompt="right-sticky"] {
	justify-content: flex-end;
	align-items: center;
}

[data-prompt="notification"] {
	align-items: flex-end;
	justify-content: flex-end;
}

[data-prompt="side-in-right"] {
	justify-content: flex-end;
}

[data-prompt="overlay"] .prompt {
	width: 100%;
	height: 100%;
}

[data-prompt="side-in-right"] .prompt {
	width: 1.5rem;
	height: 100%;
}

[data-prompt="notification"] .prompt {
	width: 1rem;
	height: 1rem;
	border-radius: 50%;
	margin-right: 1rem;
	margin-bottom: 1rem;
}

[data-prompt="right-sticky"] .prompt {
	width: 0.5rem;
	height: 3rem;
}

[data-prompt="top-sticky"] .prompt {
	width: 100%;
	height: 0.75rem;
}

.prompt-alert {
	font-family: Arial,sans-serif;
	position: absolute;
	border: 1px solid #e6e6e6;
	background: #fff;
	min-width: 100%;
	max-width: 100%;
	padding: 15px;
	border-radius: 3px;
	box-shadow: 0px 14px 24px rgb(0 0 0 / 10%);
}
.prompt-alert[data-mobile-alert]{
	font-family: Arial,sans-serif;
	min-width:100%;
	max-width:100%;
}
.prompt-alert[data-mobile-alert="popup"]{
	min-width:90%;
	max-width:90%;
}
.prompt-alert a{
	font-size:0.875rem;
	display:inline-block;
	color:#d4d4d4;
	text-decoration:none;
	font-weight:500;
}
.prompt-alert .btn {
	font-family: Arial,sans-serif;
	font-size: 0.875rem;
	border-radius: 4px;
	min-width:80px;
	border:0;
}
.prompt-alert .btn.btn-close{
	
	font-family: Arial,sans-serif;
	min-width:auto;
}
.prompt-alert .btn.btn-allow {
	font-family: Arial,sans-serif;
	background:var(--primary-color);
	color:var(--white-color);
}
.prompt-alert .btn:hover,
.prompt-alert .btn:focus{
	font-family: Arial,sans-serif;
	box-shadow:none;
	outline:none;
}
.prompt-alert .media__figure{
	max-width:40px;
	height:40px;
	margin-right:1rem;
}
.prompt-alert[data-alert="default"] {
	position: absolute;
	top: 10px;
	left: 56px;
}
.prompt-alert[data-alert="default"] .btn-allow,
.prompt-alert[data-alert="default"] .btn-allow:hover,
.prompt-alert[data-alert="default"] .btn-allow:focus,
.prompt-alert[data-alert="default"] .btn-blocked,
.prompt-alert[data-alert="default"] .btn-blocked:hover,
.prompt-alert[data-alert="default"] .btn-blocked:focus,
.prompt-alert[data-mobile-alert="default"] .btn-allow,
.prompt-alert[data-mobile-alert="default"] .btn-allow:hover,
.prompt-alert[data-mobile-alert="default"] .btn-allow:focus,
.prompt-alert[data-mobile-alert="default"] .btn-blocked,
.prompt-alert[data-mobile-alert="default"] .btn-blocked:hover,
.prompt-alert[data-mobile-alert="default"] .btn-blocked:focus{
	background:#fff;
	color:var(--primary-color);
	border:1px solid #d4d4d4;
}
.prompt-alert[data-alert="default"]:before{
	position: absolute;
	content: "";
}

[data-alert=""] {
	position: absolute;
	z-index: 3;
	border-radius: 5px;
}

[data-prompt-mobile] {
	width: 70%;
	margin: 0 auto;
	background: #F4F5F6;
}

[data-alert="slide-down"] {
	top: 1rem;
	left: 0;
	right: 0;
	margin: 0 auto;
	animation: slideDown 1s ease 0s 1 normal forwards;
}

[data-alert="popup"],
[data-mobile-alert="popup"] {
	padding: 0;
	border: 0;
	transform: translate(0, 0);
	overflow: hidden;
	border-radius: 5px;
	animation: popup 1s ease 0s 1 normal forwards;
}

[data-alert="message-box"] {
	right: 1rem;
	bottom: 1rem;
	animation: messageBox 1s ease 0s 1 normal forwards;
}

.prompt-alert[data-alert="sticky-header"] {
	top: 10px;
	min-width: 98%;
	max-width: 98%;
	width: 100%;
	display: flex;
	justify-content: space-between;
	animation: topSticky 1s ease 0s 1 normal forwards;
}
[data-alert="right-sticky"],
[data-mobile-alert="right-sticky"],
[data-alert="left-sticky"],
[data-mobile-alert="left-sticky"] {
	border: 0;
	left: calc(100% - 176px);
	right: 0;
	top: 45%;
	box-shadow: none;
	transform: rotate(-90deg);
	text-align: center;
	background: var(--primary-color);
	color: var(--white-color);
	width: 100%;
	clip-path: polygon(22% 2%, 79% 5%, 88% 100%, 10% 100%);
}
[data-mobile-alert="right-sticky"]{
	left: calc(100% - 186px);
}
[data-alert="left-sticky"],
[data-mobile-alert="left-sticky"] {
	left: -124px;
	right: auto;
	transform: rotate(90deg);
}
[data-mobile-alert="left-sticky"]{
	left: -134px;
}
[data-alert="left-sticky"]{
	left: -124px;
}
[data-alert="right-sticky"]:before,
[data-mobile-alert="right-sticky"]:before,
[data-alert="left-sticky"]:before,
[data-mobile-alert="right-sticky"]:before,
[data-alert="right-sticky"]:after,
[data-alert="left-sticky"]:after,
[data-mobile-alert="right-sticky"]:after,
[data-mobile-alert="left-sticky"]:after {

}

[data-alert="right-sticky"]:after,
[data-alert="left-sticky"]:after,
[data-mobile-alert="right-sticky"]:after,
[data-mobile-alert="left-sticky"]:after {
	clip-path: polygon(25% 0%, 91% 0%, 51% 100%, 44% 100%);
	right: -9px;
	left: auto;
}

.prompt-alert[data-alert="notification"],
.prompt-alert[data-mobile-alert="notification"] {
	min-width: 3rem;
	max-width: 3rem;
	border-radius: 50%;
	padding: 0;
	text-align: center;
	line-height: 3.5;
	height: 3rem;
	right: 1rem;
	bottom: 1rem;
	background: #2C97DE;
	color: var(--white-color);
	box-shadow: none;
	border: 0;
}

[data-alert="side-right"] {
	display: flex;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	right: 0;
	border: 0;
	height: 100%;
	box-shadow: none;
	border-radius: 0;
	padding: 2rem;
	animation: slideLeft 1s ease 0s 1 normal forwards;
}
[data-alert="side-right"] img{
	max-width:3rem;
}
.prompt-alert[data-alert="overlay"],
.prompt-alert[data-mobile-alert="overlay"] {
	display: flex;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	min-width: 100%;
	width: 100%;
	height: 100%;
	border: 0;
	box-shadow: none;
	border-radius: inherit;
	animation: overlay 1s ease 0s 1 normal forwards;
}

[data-alert="overlay"] .description {
	max-width: 100%;
}

[data-alert="popup"] .custom-description,
[data-mobile-alert="popup"] .description,
[data-mobile-alert="popup"] .custom-description	{
	font-family: Arial,sans-serif;
	padding: 1rem 2rem 0;
}
[data-alert="popup"] .custom-description{
	font-family: Arial,sans-serif;
	padding-top:1rem;
}
[data-alert="popup"] .btn,
[data-mobile-alert="popup"] .btn {
	font-size: 1rem;
	border-radius: 0;
}

.prompt-alert .btn-close i {
	font-size: 0.75rem;
}

.prompt-alert .description {
	line-height: 1;
}

.prompt-native-alert {
	width: 2rem;
	height: 0.75rem;
}

.prompt-native-dialog {
	width: 4rem;
	height: 0.75rem;
	margin: 0 auto;
}

.preview-mobile-container {
	position: relative;
	max-width: 320px;
	width: 100%;
	margin: 0 auto;
	border-radius: 1rem;
	box-shadow: 0px 0px 5px 2px rgb(0 0 0 / 25%);
	overflow: hidden;
	
}
.preview-mobile-container:before{
	position: absolute;
	content: "";
	top:0;
	left: 0;
	background:url('../images/iPhone-mask.svg') no-repeat;
}
.prompt-alert[data-mobile-alert="slideup"] {
	margin: 0 auto;
	top: auto;
	bottom: 0;
	min-width: 100%;
	max-width: 100%;
	border-radius: inherit;
	animation: mobileSlideup 1s ease 0s 1 normal forwards;
}

[data-mobile-alert="default"] {
	top: calc(50% - 50px);
	left: 0;
	right: 0;
	margin:0 auto;
}


[data-mobile-alert="popup"] {
	top: calc(50% - 75px);
	left: 0;
	right: 0;
	margin: 0 auto;
}

[data-mobile-alert="message-box"] {
	top: auto;
	bottom: 0px;
	left: 0px;
	right: 0px;
	border-radius: inherit;
	animation: mobileMessageBox 1s ease 0s 1 normal forwards;
}

[data-mobile-alert="top-sticky"] {
	top: 0px;
	left: 0px;
	right: 0px;
	border-radius: 5px;
	margin: 0 auto;
	animation: mobiletopSticky 1s ease 0s 1 normal forwards;
}
[data-platform="windows10"]{
	background:#1C1C1E;
	color: #E6E6E6;
	font-weight: var(--font-thin);
	border-radius: 0;
}
[data-platform="windows10"] .description-text{
	font-size: 0.85rem;
	color: #ffffff;
}
[data-platform="window8"] .action-buttons .btn,
[data-platform="android"] .btn{
	color: #647482;
}
.notification-wrapper .action-buttons{
	background: #F0F0F2;
}
.notification-wrapper .action-buttons button{
	min-width: auto;
}
preview-mobile-container:before {}

.br-left {
	border-left: 1px solid #e6e6e6;
}

.br-right {
	border-right: 1px solid #e6e6e6;
}

.indicators>div {
	width: 1rem;
	height: 1rem;
	background: transparent;
	border-radius: 50%;
	border: 1px soid transparent;
	margin-right: 0.5rem;
}

.indicators .red {
	background: var(--warning-color);
	border-color: var(--warning-color);
}

.indicators .grey {
	background: var(--grey-color);
	border-color: var(--grey-color);
}

.indicators .green {
	background: var(--success-color);
	border-color: var(--success-color);
}

.prompt-native {
	background: var(--bg-dark);
	color: var(--white-color);
	padding: 1rem;
	position: absolute;
}

.prompt-native p {
	font-size: 0.5rem;
}

.prompt-native .btn-neutral {
	color: var(--white-color);
}

[data-prompt-position="top"] {
	top: 0;
	left:0;
	right:0;
}

[data-prompt-position="bottom"] {
	top: auto;
	bottom:0;
	left:0;
	right:0;
}

[data-prompt-position="center"] {
	top: calc(50% - 50px);
	left:0;
	right:0;
	width: 50%;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin: 0 auto;
}

[data-prompt-position="center"] .btn {
	margin-top: 1rem;
}

.native-features>div {
	padding: 0 0.25rem !important;
}

.automation-categories {
	position: relative;
	border: 1px solid #e6e6e6;
	border-radius: 5px;
	margin: 0 0 1rem;
}
[data-toggle-position="top-right"]{
	position: absolute;
	top: 0;
	left:calc(100% - 55px);
	right:5px;
	min-width: 3rem;
    max-width: 3rem;
}
.automation-categories>div {
	padding-top: 1rem;
	padding-bottom: 1rem;
}

.automation-categories .toggle-block {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding-top: 0;
	margin-top: -0.75rem;
}

.automation-categories .toggle-block {
	position: absolute;
	top: 20px;
	right: 20px;
	left: auto;
	min-width: 2rem;
	max-width: 2rem;
}

.automation-categories>div:last-child {
	text-align: right;
	border-top: 1px solid #e6e6e6;
}

.automation-categories .br-right {
	border-right: 0;
	border-bottom: 1px solid #e6e6e6;
}

.automation-categories .toggle-control-sm {
	min-height: 2rem;
}

.automation-categories .media-rounded {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 2.5rem;
	height: 2.5rem;
	background: #F4F5F6;
	border-radius: 50%;
}

.illustration-image {
	max-width: 100%;
	width: 100%;
	height: 35vh;
}

.theme-preview-container {
	border: 6px solid #fff;
	box-shadow: 0 0 2px 0 var(--grey-color);
	min-width: 100%;
	max-width: 100%;
	border-radius: 5px;
	background: var(--bg-dark);
	color: var(--white-color);
	display: flex;
	margin:1rem auto;
}

.theme-image {
	min-width: 18rem;
	width: 100%;
	background: url('../images/Rectangle.png') no-repeat;
	background-size: cover;
	background-position: center;
	min-height: 100%;
}

.theme-description {
	padding: 10px 15px;
}
.theme-description h5,
.theme-description p{
	word-break:break-word;
}

.theme-description a:hover {
	color: var(--white-color);
	text-decoration:underline;
}

[data-theme="descriptive"] {
	padding: 2rem 2rem;
}

.theme-description .topic-btn {
	background: var(--theme-topic-button-bgcolor);
	color: var(--theme-topic-button-color);
	border-color: var(--theme-topic-button-bgcolor);
	border-radius: 5px;
}
.theme-description .theme-graphic .topic-btn{
	min-width:46%;
	max-width:46%;
	width:100%;
	margin:4px;
}
.installation-wrapper>div:nth-child(2) {
	border-left: 1px solid #e6e6e6;
	border-right: 1px solid #e6e6e6;
}

.avatar-image {
	width: 30px;
	height: 30px;
	border-radius: 50%;
	overflow: hidden;
}
.calendar-dropdown{
	border: 1px solid #e6e6e6;
	padding: 1rem;
	box-shadow: 0px 13px 26px rgba(0, 0, 0, 0.07);
	border-radius: 6px;
}
.category-buttons{
	padding-right: 4rem;
	margin-right: 2rem;
}
.calendar-dropdown button{
	text-align: left;
}

.checkbox-container {
	display: flex;
    gap: 2px;
    align-items: center;

	input {
		min-width: 35px;
	}

	label {
		margin-bottom: 0;
	}
}

.date-form-group {
	position: relative;
}
.date-form-group .calendar-dropdown{
	position: absolute;
	right: 0;
	left: auto;
	background: #fff;
	z-index: 99999;
}
.date-picker th,
.date-picker td{
	font-weight: normal;
	text-align: center;
	padding:5px;	
}
.date-picker td{
	cursor: pointer;
	width: 6px;
	height: 6px;
	border-radius: 50%;
	background: transparent;
	padding:5px;
	font-size: 0.875rem;
}
.date-picker td:hover{
	background: var(--primary-color);
	color: var(--white-color);
}
/* crate campaign notification preview */
.notification-preview-container,
.price-drop-column{
	min-width: 100%;
	max-width: 100%;
}
.react-tel-input{
	font-family: 'Poppins', sans-serif;
}
.react-tel-input .flag-dropdown,
.react-tel-input .form-control{
	border-color: #e6e6e6;
}
.react-tel-input .form-control{
	width:100%;
	border-radius:0.25rem;
}

.url-wrapper {
	text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.MuiPaper-root{
	min-width: 320px;
}
.dashboard-container{
	padding: 16px;
    width: calc(100% - 10px);
}
.threshold-wrapper{
	position:relative;
	padding-bottom:15px;
}
.threshold-wrapper .threshold-value{
	position:absolute;
	content:"";
	bottom:0;
	left:15px;
}
.masonary-wrapper{
	display: grid;
    gap: 10px;
    grid-template-columns: repeat(1, 1fr);
    grid-template-rows: masonry;
	margin-bottom: 2rem;
}
.masonary-wrapper > div {
	// display: grid;
	// grid-template-rows: 1fr auto;
	//grid-template-rows: masonry;
	// margin-bottom: 10px;
	// break-inside: avoid;
}
/* permission prompt animation css */
@keyframes slideDown {
	0% {
	  transform: translateY(-100%);
	}
  
	100% {
	  transform: translateY(0);
	}
  }
  @keyframes popup {
	0% {
	  transform: scale(0.5);
	}
	
	100% {
	  transform: scale(1);
	}
  }
  @keyframes messageBox {
	0% {
	  transform: translateY(100%);
	}
  
	100% {
	  transform: translateY(0);
	}
  }
  @keyframes topSticky {
	0% {
	  transform: translateY(-100%);
	}
  
	100% {
	  transform: translateY(0);
	}
  }
  @keyframes bell {
	0%,
	100% {
	  transform: translateX(0%);
	  transform-origin: 50% 50%;
	}
  
	15% {
	  transform: translateX(-5px) rotate(-6deg);
	}
  
	30% {
	  transform: translateX(5px) rotate(6deg);
	}
  
	45% {
	  transform: translateX(-5px) rotate(-3.6deg);
	}
  
	60% {
	  transform: translateX(5px) rotate(2.4deg);
	}
  
	75% {
	  transform: translateX(-2px) rotate(-1.2deg);
	}
  }
  @keyframes slideLeft {
	0% {
	  transform: translateX(100%);
	}
  
	100% {
	  transform: translateX(0);
	}
  }
  @keyframes overlay {
	0% {
	  transform: scale(0);
	}
  
	100% {
	  transform: scale(1);
	}
  }
  @keyframes mobileSlideup {
	0% {
	  transform: translateY(100%);
	}
  
	100% {
	  transform: translateY(0);
	}
  }



  @keyframes mobileMessageBox {
	0% {
	  transform: translateY(100%);
	}
  
	100% {
	  transform: translateY(0);
	}
  }
  @keyframes mobiletopSticky {
	0% {
	  transform: translateY(-100%);
	}
  
	100% {
	  transform: translateY(0);
	}
  }
  .cart-notification-wrapper{
	  display:flex;
	  flex-wrap:wrap;
	  justify-content:space-between;
  }
  .cart-notification-wrapper .box{
	  width:100%;
	  margin:15px 0px;
  }

 ${ /*Responsive CSS */'' }

 @media (min-width: 576px) {
	.col-sm {
		-ms-flex-preferred-size: 0;
		flex-basis: 0;
		-webkit-box-flex: 1;
		-ms-flex-positive: 1;
		flex-grow: 1;
		max-width: 100%;
	}
	.col-sm-auto {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 auto;
		flex: 0 0 auto;
		width: auto;
		max-width: none;
	}
	.col-sm-1 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 8.333333%;
		flex: 0 0 8.333333%;
		max-width: 8.333333%;
	}
	.col-sm-2 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 16.666667%;
		flex: 0 0 16.666667%;
		max-width: 16.666667%;
	}
	.col-sm-3 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 25%;
		flex: 0 0 25%;
		max-width: 25%;
	}
	.col-sm-4 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 33.333333%;
		flex: 0 0 33.333333%;
		max-width: 33.333333%;
	}
	.col-sm-5 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 41.666667%;
		flex: 0 0 41.666667%;
		max-width: 41.666667%;
	}
	.col-sm-6 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 50%;
		flex: 0 0 50%;
		max-width: 50%;
	}
	.col-sm-7 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 58.333333%;
		flex: 0 0 58.333333%;
		max-width: 58.333333%;
	}
	.col-sm-8 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 66.666667%;
		flex: 0 0 66.666667%;
		max-width: 66.666667%;
	}
	.col-sm-9 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 75%;
		flex: 0 0 75%;
		max-width: 75%;
	}
	.col-sm-10 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 83.333333%;
		flex: 0 0 83.333333%;
		max-width: 83.333333%;
	}
	.col-sm-11 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 91.666667%;
		flex: 0 0 91.666667%;
		max-width: 91.666667%;
	}
	.col-sm-12 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 100%;
		flex: 0 0 100%;
		max-width: 100%;
	}
	.modal-dialog {
		max-width: 500px;
		margin: 1.75rem auto;
	}
	.modal-dialog-centered {
		min-height: calc(100% - (1.75rem * 2));
	}
	.modal-sm {
		max-width: 300px;
	}
	.login-container {
		padding: 0 10rem;
	}
	.d-sm-none {
		display: none !important;
	}
	.masonary-wrapper{
		column-count: 1;
		column-gap: 10px;
	}
}

@media (min-width: 768px) {
	.col-md {
		-ms-flex-preferred-size: 0;
		flex-basis: 0;
		-webkit-box-flex: 1;
		-ms-flex-positive: 1;
		flex-grow: 1;
		max-width: 100%;
	}
	.col-md-auto {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 auto;
		flex: 0 0 auto;
		width: auto;
		max-width: none;
	}
	.col-md-1 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 8.333333%;
		flex: 0 0 8.333333%;
		max-width: 8.333333%;
	}
	.col-md-2 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 16.666667%;
		flex: 0 0 16.666667%;
		max-width: 16.666667%;
	}
	.col-md-3 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 25%;
		flex: 0 0 25%;
		max-width: 25%;
	}
	.col-md-4 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 33.333333%;
		flex: 0 0 33.333333%;
		max-width: 33.333333%;
	}
	.col-md-5 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 41.666667%;
		flex: 0 0 41.666667%;
		max-width: 41.666667%;
	}
	.col-md-6 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 50%;
		flex: 0 0 50%;
		max-width: 50%;
	}
	.col-md-7 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 58.333333%;
		flex: 0 0 58.333333%;
		max-width: 58.333333%;
	}
	.col-md-8 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 66.666667%;
		flex: 0 0 66.666667%;
		max-width: 66.666667%;
	}
	.col-md-9 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 75%;
		flex: 0 0 75%;
		max-width: 75%;
	}
	.col-md-10 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 83.333333%;
		flex: 0 0 83.333333%;
		max-width: 83.333333%;
	}
	.col-md-11 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 91.666667%;
		flex: 0 0 91.666667%;
		max-width: 91.666667%;
	}
	.col-md-12 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 100%;
		flex: 0 0 100%;
		max-width: 100%;
	}
	.d-md-none {
		display: none !important;
	}
	.d-md-block {
		display: block !important;
	}
	.logo-container img {
		max-width: 15rem;
	}
	.error-container .description {
		max-width: 40%;
	}
	.btn {
		font-size: 1rem;
	}
	.toggle-control {
		margin-bottom: 0;
	}
	header {
		padding: 0 2rem;
	}
	header .custom-select {
		position: relative;
		width: 100%;
		left: unset;
		top: unset;
	}
	.segments-tabs .accordion-title {
		display: none;
	}
	.segments-tabs .accordion {
		border: 0;
	}
	.horizontal-tabs {
		display: flex;
	}
	.add-segment-wrapper .filter-panel {
		border: 1px solid #e6e6e6;
	}
	.filter-feature:nth-child(2) {
		border: 0;
		border-left: 1px solid #e6e6e6;
		border-right: 1px solid #e6e6e6;
	}
	.segment-info {
		border-left: 1px solid #e6e6e6;
	}
	.panel-body {
		padding: 1.5rem;
	}
	.btn.toggle-btn-rounded {
		display: none;
	}
	.horizontal-tabs a {
		font-size: 1rem;
	}
	.prompt-container .content-box {
		height: 12rem;
	}
	.toggle-control-xs {
		min-width: 2rem;
		max-width: 2rem;
	}
	.toggle-control-sm {
		min-width: 3rem;
		max-width: 3rem;
		height: auto;
	}
	/* .automation-categories > div:nth-child(5) {
      position: relative;
      top:unset;
      left: unset;
      right: unset;
      min-width: 5rem;
      max-width: 5rem;
    } */
	.automation-categories>div:last-child {
		text-align: right;
		border-top: 0;
	}
	.automation-categories .br-right {
		border-right: 1px solid #e6e6e6;
		border-bottom: 0;
	}
	.custom-select-md {
		min-width: 18rem;
		max-width: 18rem;
	}
	.theme-preview-container {
		min-width: 44rem;
		max-width: 44rem;
	}
	.prompt-alert {
		min-width: 370px;
		max-width: 370px;
	}
	
	.prompt-alert[data-alert="side-right"]{
		min-width:300px;
		max-width:300px;
	}
	.prompt-alert[data-mobile-alert="message-box"]{
		min-width:100%;
		max-width:100%;
	}
	.prompt-alert[data-alert="popup"]{
		min-width:400px;
		max-width:400px;
	}
	.MuiPaper-root{
		min-width: 400px;
	}
	aside {
		min-width: 230px;
		max-width: 230px;
	}
	.open-nav:before{
		display:none;
	}
	.custom-radio .custom-control-input:checked~.custom-control-label::after {
		top: -1px;
		left: -25px;
		width: 26px;
		height: 26px;
	}
	.website-title{
		width:200px;
	}
	[data-alert="right-sticky"], [data-mobile-alert="right-sticky"], 
	[data-alert="left-sticky"], [data-mobile-alert="left-sticky"]{
		min-width:300px;
		max-width:300px;
	}
	.topics-table .btn-primary{
		mx-width:150px;
		margin-left:auto;
	}
	.masonary-wrapper{
		grid-template-columns: repeat(2, 1fr);
	    column-gap: 10px;
	}
	.prompt-alert[data-alert="message-box"],
	[data-alert="slide-down"]{
		min-width:400px;
		max-width:400px;
	}
	.cart-notification-wrapper .box{
		width:48%;
	}
}

@media (min-width: 991px) {
	.col-lg {
		-ms-flex-preferred-size: 0;
		flex-basis: 0;
		-webkit-box-flex: 1;
		-ms-flex-positive: 1;
		flex-grow: 1;
		max-width: 100%;
	}
	.col-lg-auto {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 auto;
		flex: 0 0 auto;
		width: auto;
		max-width: none;
	}
	.col-lg-1 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 8.333333%;
		flex: 0 0 8.333333%;
		max-width: 8.333333%;
	}
	.col-lg-2 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 16.666667%;
		flex: 0 0 16.666667%;
		max-width: 16.666667%;
	}
	.col-lg-3 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 25%;
		flex: 0 0 25%;
		max-width: 25%;
	}
	.col-lg-4 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 33.333333%;
		flex: 0 0 33.333333%;
		max-width: 33.333333%;
	}
	.col-lg-5 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 41.666667%;
		flex: 0 0 41.666667%;
		max-width: 41.666667%;
	}
	.col-lg-6 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 50%;
		flex: 0 0 50%;
		max-width: 50%;
	}
	.col-lg-7 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 58.333333%;
		flex: 0 0 58.333333%;
		max-width: 58.333333%;
	}
	.col-lg-8 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 66.666667%;
		flex: 0 0 66.666667%;
		max-width: 66.666667%;
	}
	.col-lg-9 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 75%;
		flex: 0 0 75%;
		max-width: 75%;
	}
	.col-lg-10 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 83.333333%;
		flex: 0 0 83.333333%;
		max-width: 83.333333%;
	}
	.col-lg-11 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 91.666667%;
		flex: 0 0 91.666667%;
		max-width: 91.666667%;
	}
	.col-lg-12 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 100%;
		flex: 0 0 100%;
		max-width: 100%;
	}
	.modal-lg {
		max-width: 800px;
	}
	.d-lg-none {
		display: none !important;
	}
	.d-lg-block {
		display: block !important;
	}
	.login-container {
		max-width: 70%;
		padding: 0;
	}
	aside {
		display: flex;
		min-width: 200px;
		max-width: 200px;
		position: relative;
	}
	header .custom-select {
		position: relative;
		min-width: 14rem;
	}
	header .custom-select i {
		top: 10px;
		left: 10px;
	}
	.btn-toggle {
		display: none;
	}
	aside {
		transform: translateX(0);
	}
	.dropdown-toggle {
		min-width: 9rem;
	}
	.dropdown-toggle:before {
		display: block;
		margin-left:0.5rem;
	}
	.logo-container-sm {
		padding: 0.75rem 0.5rem;
		border-bottom: #e6e6e6;
		position: relative;
		top: unset;
		min-height: 50px;
	}
	.map-container img {
		height: 250px;
	}
	.graph-container img {
		height: 250px;
	}
	.subscription-table thead th:first-child {
		min-width: 350px;
	}
	.subscription-table thead th:nth-child(2) {
		min-width: 350px;
	}
	.modal-medium .modal-dialog {
		min-width: 800px;
	}
	.prompt-container .content-box {
		height: 12rem;
	}
	.prompt-container .title {
		font-size: 0.975rem;
	}
	.prompt-native p {
		font-size: 0.875rem;
	}
	.automation-categories .toggle-block {
		position: relative;
		top: unset;
		right: unset;
		left: unset;
	}
	.notification-preview-container,
	.price-drop-column{
		min-width:350px;
		max-width:350px;
	}
	.panel-header h3{
		margin-bottom:0 !important;
	}
	[data-toggle-position="top-right"]{
		position: relative; 
		top: unset;
		left: unset;
		right: unset;
		min-width: auto;
		max-width: fit-content;
	}
	.btn i{
		font-size:0.875rem;
	}
	.theme-description {
		padding: 1rem 1.5rem;
	}
	[data-toggle-position="top-right"]{
		margin-top:0.25rem;
	}
	.masonary-wrapper{
		grid-template-columns: repeat(2, 1fr);
	}
	.cart-notification-wrapper .box{
		width:48%;
	}	
}

@media (min-width: 1200px) {
	html {
		font-size: 14px;
	}
	.col-xl {
		-ms-flex-preferred-size: 0;
		flex-basis: 0;
		-webkit-box-flex: 1;
		-ms-flex-positive: 1;
		flex-grow: 1;
		max-width: 100%;
	}
	.col-xl-auto {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 auto;
		flex: 0 0 auto;
		width: auto;
		max-width: none;
	}
	.col-xl-1 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 8.333333%;
		flex: 0 0 8.333333%;
		max-width: 8.333333%;
	}
	.col-xl-2 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 16.666667%;
		flex: 0 0 16.666667%;
		max-width: 16.666667%;
	}
	.col-xl-3 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 25%;
		flex: 0 0 25%;
		max-width: 25%;
	}
	.col-xl-4 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 33.333333%;
		flex: 0 0 33.333333%;
		max-width: 33.333333%;
	}
	.col-xl-5 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 41.666667%;
		flex: 0 0 41.666667%;
		max-width: 41.666667%;
	}
	.col-xl-6 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 50%;
		flex: 0 0 50%;
		max-width: 50%;
	}
	.col-xl-7 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 58.333333%;
		flex: 0 0 58.333333%;
		max-width: 58.333333%;
	}
	.col-xl-8 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 66.666667%;
		flex: 0 0 66.666667%;
		max-width: 66.666667%;
	}
	.col-xl-9 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 75%;
		flex: 0 0 75%;
		max-width: 75%;
	}
	.col-xl-10 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 83.333333%;
		flex: 0 0 83.333333%;
		max-width: 83.333333%;
	}
	.col-xl-11 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 91.666667%;
		flex: 0 0 91.666667%;
		max-width: 91.666667%;
	}
	.col-xl-12 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 100%;
		flex: 0 0 100%;
		max-width: 100%;
	}
	.d-xl-none {
		display: none !important;
	}
	.d-xl-block {
		display: block !important;
	}
	.login-container {
		max-width: 50%;
		padding: 0;
	}
	.bg-login img {
		max-width: 40rem;
	}
	.modal-medium .modal-dialog {
		min-width: 1100px;
	}
	.prompt-container .content-box {
		height: 7rem;
	}
	.automation-categories {
		margin: 0 0 1rem;
	}
	.navigation-menu li {
		padding:7px 0 7px 0px;
	}
	.masonary-wrapper{
		column-count: 3;
	}
	.custom-radio .custom-control-input:checked~.custom-control-label::after{
		left: -25px;
	}
	.masonary-wrapper{
		grid-template-columns: repeat(3, 1fr);
	}
}

@media (min-width: 1280px){
	.notification-preview-container,
	.price-drop-column{
		min-width:450px;
		max-width:450px;
	}
}

@media (min-width: 1440px){
	.cart-notification-wrapper .box{
		width:33%;
		margin: 15px 0;
	}
}

@media (min-width: 1600px) {
	html {
		font-size: 16px;
	}
	.notification-preview-container,
	.price-drop-column{
		min-width:500px;
		max-width:500px;
	}
	.masonary-wrapper{
		grid-template-columns: repeat(4, 1fr);
	}
	.prompt-alert[data-alert="message-box"],
	[data-alert="slide-down"]{
		min-width:450px;
		max-width:450px;
	}
	aside{
		min-width:275px;
		max-width:275px;
	}
}

@media(max-width:767px) {
	.prompt-alert {
		min-width:100%;
		max-width:100%;
	}
	.theme-preview-container{
		flex-direction:column;
	}
	.theme-image{
		min-height:200px;
	}
	.theme-description{
		padding:5px;
	}
	.theme-description small{
		padding:0 !important;
	}
	.theme-description .theme-graphic .topic-btn{
		min-width:47%;
		max-width:47%;
		margin:0 3px;
	}
	[data-theme="descriptive"]{
		padding:10px;
	}
	.prompt-container .content-box{
		height:5rem;
	}
	.prompt-container .custom-checkbox{
		top:18px;
	}
	.custom-control-label::before{
		width: 12px;
    	height: 12px;
	}
	.custom-control-label::after{
		top: 4px;
		left: -19px;
	}
	.preview-mobile-container{
		display:none;
	}
}

@media screen and (max-width: 800px) {
	.column {
		-ms-flex: 50%;
		flex: 50%;
		max-width: 50%;
	}
}

@media screen and (max-width: 600px) {
	.column {
		-ms-flex: 100%;
		flex: 100%;
		max-width: 100%;
	}
	.installation-wrapper>div {
		padding: 2rem;
	}
	.installation-wrapper>div:nth-child(2) {
		border: 0;
		border-top: 1px solid #e6e6e6;
		border-bottom: 1px solid #e6e6e6;
	}
}

.text-uppercase {
	text-transform: uppercase;
}

.pricing-details.bg-grey {
	margin: 0 -0.875rem;
}

.pricing-details li {
	display: flex;
	justify-content: space-between;
	font-size: 0.875rem;
	margin-bottom: 0.25rem;
}

.card-placeholder {
	width: 25px;
	height: 25px;
	margin: 0 0.25rem;
}

.badge {
	display: inline-block;
	background: #e6e6e6;
	padding: 2px 5px;
	border-radius: 5px;
	font-size: 11px;
	margin: 0 5px;
	line-height: normal;
}

.toggleWrapper {
	display:flex;
	justify-content:center;
}

.toggleWrapper input {
	position: absolute;
	opacity: 0;
}

.toggle {
	cursor: pointer;
	display: inline-block;
	position: relative;
	width: 76px;
	height: 35px;
	background-color: #fff;
	border-radius: 84px;
	border: 1px solid #2C97DE;
	transition: background-color 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
}

.toggle:before,
.toggle:after {
	content: "Subscriber Based";
	position: absolute;
	left: -170px;
	font-size: 18px;
	font-weight: 600;
	color: var(--primary-color);
}

.toggle:after {
	content: "Impresssion Based";
	left:auto;
	right: -180px;
	color: #000;
}

.toggle__handler {
	display: inline-block;
	position: relative;
	z-index: 1;
	top: 3px;
	left: 3px;
	width: 26px;
	height: 26px;
	background-color: #2C97DE;
	border-radius: 50px;
	box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
	transition: all 400ms cubic-bezier(0.68, -0.55, 0.265, 1.55);
	transform: rotate(-45deg);
}


input:checked+.toggle {
	background-color: #fff;
}

input:checked+.toggle:before {
	color: #000;
}

input:checked+.toggle:after {
	color: #2C97DE;
}

input:checked+.toggle .toggle__handler {
	background-color: #2C97DE;
	transform: translate3d(40px, 0, 0) rotate(0);
}

.nav {
	display: -ms-flexbox;
	display: flex;
	-ms-flex-wrap: wrap;
	flex-wrap: wrap;
	padding-left: 0;
	list-style: none;
	margin: 1rem 0;
}

.nav-link {
	display: block;
	padding: 0.5rem 1.75rem;
	font-size: 1.25rem;
	font-weight: 600;
	text-decoration: none;
	color: #000;
}

.nav-link:hover {
	text-decoration: none;
}

.nav-pills .nav-link.active,
.nav-pills .show>.nav-link {
	color: #fff;
	border-radius: 32px;
	background-color: #007bff;
	box-shadow:0 0 12px 0 rgb(0 123 255 / 45%);
}

.modal-header .close {
	position: absolute;
	right: 15px;
	border: 0;
	background: transparent;
	font-size: 2rem;
	top: 5px;
	cursor: pointer;
}

.tab-content>.tab-pane {
	display: none;
}

.tab-content>.active {
	display: block;
}

.price-card {
	border-radius: 8px;
	border: 1px solid rgba(37, 56, 88, .1);
	margin-bottom: 2rem;
}

.card-header {
	position: relative;
}

.card-header h4 {
	color: #fff;
	position: absolute;
	top: -18px;
	left: 0;
	right: 0;
	border: 1px solid var(--primary-color);
	border-radius: 20px;
	max-width: 60%;
	margin: 0 auto;
	z-index: 5;
	font-size: 0.975rem;
	font-weight: normal;
	background: var(--primary-color);
	padding: 5px;
}

.price-card .card-header {
	background-color: #e0e3e6;
	border-radius: 8px 8px 0 0;
	padding: 12px 0;
	font-size: 1.5rem;
	font-weight: 600;
}

.price-card.active {
	border: 2px solid var(--primary-color);
}

.price-card.active .card-header {
	background-color: #eaf5fc;
}

.price-card .btn{
	min-width: 185px;
	font-size: 1rem;
	font-weight: 600;
	line-height: 1.5;
	padding: 0.75rem 0;            
}

.feature-list li {
	display: block;
	position: relative;
	text-align: left;
	margin-bottom: 0.45rem;
	font-size: 0.875rem;
	font-weight: 300;
	padding-left: 20px;
	color: #253858;
}

.feature-list li i {
	position: absolute;
	font-size: 0.5rem;
	margin-right: 1rem;
	background: var(--primary-color);
	left: 0;
	top: 2px;
	font-size: 0.45rem;
	color: var(--primary-color);
	background: rgba(44, 151, 222, 0.2);
	width: 15px;
	height: 15px;
	line-height: 1.5;
	border-radius: 50%;
	padding: 4px;
}

.modal-body {
	max-height: 85vh;
}

.price {
	font-size: 2rem;
	font-weight: 600;
	color: var(--primary-color);
}

.price span {
	font-size: 1rem;
	font-weight: 300;
	color: #000;
}

.cards-wrapper .col-12:nth-child(odd) {
	padding-top: 2rem;
}
.slider{
	-webkit-appearance: none;
    -moz-appearance: none;
    width: 100%;
    height: 10px;
    border-radius: 5px;
    background: #dde5ff;
    outline: 0;
    opacity: .7;
    transition: opacity .2s;
}
input[type=range],input[type=range]::-moz-range-track {
    -webkit-appearance: none;
    -moz-appearance: none;
    width: 100%;
    border-radius: 5px;
    background: #dde5ff;
    outline: 0;
    -moz-transition: opacity .2s;
    transition: opacity .2s
}

input[type=range]::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background: #2b8aeb;
    cursor: pointer;
    outline: 0
}

input[type=range]::-moz-range-thumb {
    -moz-appearance: none;
    appearance: none;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #1492ea;
    cursor: pointer;
    outline: 0;
    z-index: 10
}

input[type=range]:focus {
    outline: 0
}
.label-container{
	display: flex;
    justify-content: space-between;
}
.label-slider{
	color: #253858;
    font-size: 12px;
    font-weight: 600;
    -webkit-tap-highlight-color: transparent;
    cursor: pointer;
	margin-right:-1rem;
}



.slider-container input[type="range"]{
	width:100%;
}
.nav-pills{
	max-width: 18rem;
    margin: 1rem auto;
	background:#f4fafd;
	border-radius: 32px;
}
@media(max-width:767px) {
	.toggleWrapper {
		padding: 0 110px;
		margin-bottom: 1.5rem;
	}

	.toggle:before,
	.toggle:after {
		left: -110px;
		word-break: break-all;
		max-width: 100px;
	}

	.toggle:after {
		left: auto;
		right: -110px;
	}

	.cards-wrapper .col-12:nth-child(odd) {
		padding-top: 0;
	}

	.price-card {
		margin-bottom: 2rem;
	}
}

.premium-lock-bg {
    padding: 0px 7px;
    color: #2C97DE;
    align-items: center;
    border-radius: 5px;
	align-items: center;
    justify-content: center;
    display: flex;
    gap: 0.5rem;
	cursor: pointer;
}

.sucess-check, .failure-check {
	width: 3rem;
	height: 3rem;
	border-radius: 50%;
	background: var(--success-color);
	color: var(--white-color);
	display: flex;
	align-items: center;
	justify-content: center;
}

.failure-check {
	background: var(--warning-color);
}

.modal-center{
	top: 25%;
}

.icon-gold {
	color: gold !important;
}

.terms-link:hover {
	color: var(--primary-color);
    cursor: pointer;
	text-decoration: underline;
}

.cursor-pointer {
	cursor: pointer;
}
.overflow-hidden {
	overflow: hidden;
}

.bg-white {
	background: var(--white-color);
}

.txt-primary {
	color: var(--primary-color);
}

.sus-banner {
	background: var(--warning-color);
    color: var(--white-color);
    text-align: center;
    padding: 10px;
    position: sticky;
    top: 0;
}

.upgrade-text {
	text-decoration: underline;
	cursor: pointer;
}
.upgrade-text:hover {
	font-weight: bold;
}

.word-wrap {
	word-break: break-all;
}
@media(min-width:1280px){
	.pricing-modal .modal-dialog{
		min-width:1140px;
	}
}

@media(min-width:1400px){
	.pricing-modal .modal-dialog{
		min-width:1280px;
	}
}


 // Facebook click page

.lds-banner {
    background: var(--white-color);
    height: 100%;
    display: flex;
    color: var(--dark-color);
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1rem;
}

.lds-facebook {
	display: inline-block;
	position: relative;
	width: 80px;
	height: 80px;
  }
  .lds-facebook div {
	display: inline-block;
	position: absolute;
	left: 8px;
	width: 16px;
	background: var(--grey-color);
	animation: lds-facebook 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  }
  .lds-facebook div:nth-child(1) {
	left: 8px;
	animation-delay: -0.24s;
  }
  .lds-facebook div:nth-child(2) {
	left: 32px;
	animation-delay: -0.12s;
  }
  .lds-facebook div:nth-child(3) {
	left: 56px;
	animation-delay: 0;
  }
  @keyframes lds-facebook {
	0% {
	  top: 8px;
	  height: 64px;
	}
	50%, 100% {
	  top: 24px;
	  height: 32px;
	}
  }
  
`